import { MemoryStorage as Ue, LocalStorage as De, ORIGINS as un, getPhoneNumberString as Dn, isBlobInstance as qn } from "@chekin/core";
import { IVStatus as Mi } from "@chekin/core";
import Fe from "i18next";
import { configureRefreshFetch as Bn, fetchJSON as Xt } from "refresh-fetch";
import * as Gn from "@sentry/react";
const ke = class ke {
  static getDecryptionManager() {
    return ke.instance;
  }
  static setDecryptionManager(e) {
    ke.instance = e;
  }
  static clearDecryptionManager() {
    ke.instance = null;
  }
  static isDecryptionEnabled() {
    return ke.instance?.isEnabled() ?? !1;
  }
};
ke.instance = null;
let Ie = ke;
const Ae = class Ae {
  static get isSDK() {
    return this._isSDK;
  }
  static setIsSDK(e) {
    this._isSDK = e;
  }
  static setInitParams(e) {
    this.initParams = e;
  }
  static setJwtToken(e) {
    const t = Ie.getDecryptionManager();
    t && t.setJwtToken(e);
  }
};
Ae.initParams = { apikey: "" }, Ae._isSDK = !0;
let K = Ae;
class Q {
  static checkEmptyArray(e) {
    return !e || !Array.isArray(e);
  }
  static getSpanishCitiesAsOptions(e) {
    const t = e?.results;
    return Q.checkEmptyArray(t) ? [] : t.map((n) => ({
      label: n.name,
      value: n.code
    }));
  }
  static getCountriesAsOptions(e) {
    const t = e?.results;
    return Q.checkEmptyArray(t) ? [] : t?.map((n) => ({
      label: n?.country?.name,
      value: n?.country?.code,
      data: n
    }));
  }
  static getProvincesAsOptions(e) {
    const t = e?.results;
    return Q.checkEmptyArray(t) ? [] : t?.map((n) => ({
      label: n?.division_level_2?.name,
      value: n?.division_level_2?.code
    }));
  }
  static getCitiesAsOptions(e) {
    const t = e?.results;
    return Q.checkEmptyArray(t) ? [] : t?.map((n) => ({
      value: n?.division_level_3?.code,
      label: n?.division_level_3?.name
    }));
  }
  static getDistrictsAsOptions(e) {
    const t = e?.results;
    return Q.checkEmptyArray(t) ? [] : t?.map((n) => ({
      label: n?.division_level_1?.name,
      value: n?.division_level_1?.code
    }));
  }
  static getPhoneCodesAsOptions(e) {
    const t = e?.results;
    return Q.checkEmptyArray(t) ? [] : t?.map((n) => {
      const a = `+${n.phone_code}`;
      return {
        value: a,
        label: `${n?.country?.name} ${a}`
      };
    });
  }
}
const ln = {
  decryptionError: 1111
};
class Zt extends Error {
  constructor(e, t, n) {
    super(e), this.name = "CustomError", this.code = t, this.details = n, this.timestamp = /* @__PURE__ */ new Date(), Error.captureStackTrace(this, this.constructor);
  }
}
const Un = async (r, e) => {
  const t = Ie.getDecryptionManager();
  let n = null;
  if (t?.isEnabled() && e?.requireEncryption) {
    n = await t.getDecryptionKey();
    const a = t.getEncryptionHeaders();
    Object.keys(a).length > 0 && (e.headers ? Object.entries(a).forEach(([l, h]) => {
      e.headers.set(l, h);
    }) : e.headers = new Headers(a));
  }
  return new Promise((a, l) => fetch(r, e).then(async (h) => {
    let f = await An(h);
    if (t?.isEnabled() && t.isResponseEncrypted(h) && n)
      try {
        f = await t.decryptResponse(
          f,
          n
        );
      } catch (S) {
        throw console.error("Failed to decrypt response:", S), Gn.captureMessage("Failed to decrypt response"), new Zt(
          Fe.t("something_went_wrong"),
          ln.decryptionError
        );
      }
    return jn({ response: h, body: f });
  }).then(a).catch(l));
}, An = (r) => {
  const e = r.headers.get("content-type");
  return e && e.indexOf("json") >= 0 ? r.clone().text().then(Fn) : r.clone().text();
}, Fn = (r) => {
  if (!r)
    return null;
  try {
    return JSON.parse(r);
  } catch {
    throw new Error(`Failed to parse unexpected JSON response: ${r}`);
  }
};
class Kn extends Error {
  constructor(e, t, n) {
    super(), this.name = "ResponseError", this.status = e, this.response = t, this.body = n;
  }
}
const jn = ({ response: r, body: e }) => {
  if (r.ok)
    return { response: r, body: e };
  throw new Kn(r.status, r, e);
}, pn = "chekin-token", Wn = "guest-token", fn = "i18nextLng", qi = 2, Bi = {
  multiPaymentUpdated: "MULTI_PAYMENT_UPDATED",
  ivStartedOnMobile: "IV_STARTED_ON_MOBILE",
  ivCompletedReturningToDesktop: "IV_COMPLETED_RETURNING_TO_DESKTOP",
  ivCompletedContinuedOnMobile: "IV_COMPLETED_CONTINUE_ON_MOBILE",
  airaloPaymentsCreated: "AIRALO_PAYMENTS_CREATED"
};
class yn {
  static getToken() {
    if (K.isSDK)
      return Ue.get(this.key);
    try {
      return De.get(this.key) ?? null;
    } catch (e) {
      return console.error(e), null;
    }
  }
  static persistToken(e = "") {
    K.isSDK ? Ue.set(this.key, e) : De.set(this.key, e);
  }
  static removeToken() {
    K.isSDK ? Ue.remove(this.key) : De.remove(this.key);
  }
  static hasToken() {
    return !!this.getToken();
  }
}
const rr = class rr extends yn {
};
rr.key = pn;
let oe = rr;
const nr = class nr extends yn {
};
nr.key = Wn;
let Se = nr;
const Ke = {
  refresh: () => "api/v3/checkin-online-token/refresh/",
  apikeyAuth: () => "sdk/api/v1/apikey-auth",
  shortLink: (r) => `api/short-link/${r}/`,
  ipDetails: () => "api/v3/get-country-by-ip/",
  usersInitiate: () => "api/v1/guest-accounts/users/initiate/",
  usersFinalize: () => "api/v1/guest-accounts/users/finalize/",
  guestToken: () => "api/v1/guest-accounts/token/",
  refreshGuestToken: () => "api/v1/guest-accounts/token/renew/",
  me: () => "api/v1/guest-accounts/users/me/",
  googleCallback: () => "api/v1/guest-accounts/oauth/google/callback/",
  participants: (r = "") => `api/v1/guest-accounts/participants/${r ? `?id=${r}` : ""}`
}, Mn = (r, e, t) => {
  const n = K.initParams?.apikey, a = new Headers(r || { "Content-Type": "application/json" });
  if (a.set("embedded-sdk-app", n), a.set("X-source", un.embeddedGuestApp), e)
    return a.has("Content-Type") || a.set("Content-Type", "application/json"), a;
  const l = Se.getToken();
  l && t && !t.includes("/documents/") && !t.includes("/upselling/") && a.set("X-Guest-Token", `JWT ${l}`);
  const h = Ue.get(pn), S = De.get(fn)?.slice(0, 2);
  return S && a.set("Accept-Language", S), h && a.set("Authorization", `JWT ${h}`), a;
}, Vn = (r, e, t) => {
  const n = new Headers(r || { "Content-Type": "application/json" }), a = t?.includes("v1/guest-accounts"), l = Se.getToken(), h = a && !e && l;
  if (n.set("X-source", un.guestAppV2), e)
    return n.has("Content-Type") || n.set("Content-Type", "application/json"), n;
  l && t && !t.includes("/documents/") && !t.includes("/upselling/") && n.set("X-Guest-Token", `JWT ${l}`);
  const f = h ? l : oe.getToken(), v = De.get(fn)?.slice(0, 2);
  return v && n.set("Accept-Language", v), f && n.set("Authorization", `JWT ${f}`), n;
}, dn = (r, e, t) => K.isSDK ? Mn(r, e, t) : Vn(r, e, t), Hn = "https://api-ng.chekintest.xyz", zn = [400, 401], Lt = ["Failed to fetch", "Load Failed", "NetworkError"], Jn = "ERR_INTERNET_DISCONNECTED", Qn = [500, 502, 503, 504, 400], Gi = [ln.decryptionError], Xn = 0;
function je(r = "") {
  return `${Hn}/${r}`;
}
function Zn(r, e, t) {
  const n = r?.status;
  return t && Lt.includes(t) ? {
    message: "You have not internet connection.",
    status: 1001,
    body: e,
    name: Jn
  } : r ? r && zn.includes(r.status) ? e && { ...e, business_status: e.status, status: n } : (r?.status, r?.status === 404 ? {
    message: "404 Not found. Please contact support.",
    status: n,
    body: e
  } : r?.status === 405 ? {
    message: "405 Method not allowed. Please contact support.",
    status: n,
    body: e
  } : r?.status === 429 ? {
    message: Fe.t("too_many_requests"),
    status: n,
    body: e
  } : r?.status === 500 ? {
    message: "500 Internal Server error. Please contact support.",
    status: n,
    body: e
  } : r?.status === 502 ? {
    message: "502 Bad Gateway. Please contact support.",
    status: n,
    body: e
  } : r?.status === 503 ? {
    message: "503 Service Unavailable. Please contact support.",
    status: n,
    body: e
  } : r?.status === 504 ? {
    message: "504 Gateway Timeout. Please contact support.",
    status: n,
    body: e
  } : null) : null;
}
function Ln(r) {
  return Math.min(1e3 * 2 ** r, 3e4);
}
function Yn(r) {
  return new Promise((e) => {
    setTimeout(e, r);
  });
}
const hn = (r) => "response" in r, gn = (r) => "message" in r;
function ea({ retryCount: r = 0, errorRetryLimit: e }, t) {
  const n = K.initParams?.maxRequestsRetriesCount, a = e ?? n ?? Xn, l = gn(t) && Lt.includes(t?.message), h = t instanceof Zt, f = hn(t) && Qn.includes(t?.response?.status);
  return (l || f || h) && r < a;
}
const ta = (r, { publicAccess: e, headers: t, ...n } = {}) => {
  const a = dn(t, e, r);
  return Un(r, { ...n, headers: a });
}, ra = (r) => r.message && Lt.includes(r.message) ? !0 : r.response && r.response.status === 401, na = async () => {
  const r = K.initParams, e = JSON.stringify({
    apikey: r.apikey,
    resource_id: r.resourceId,
    external_resource_id: r.externalResourceId,
    resource_type: r.resourceType
  });
  return (await Xt(
    je(Ke.apikeyAuth()),
    {
      method: "POST",
      headers: dn(null, !0),
      body: e
    }
  )).body?.access_token;
}, aa = async () => {
  const r = oe.getToken(), e = JSON.stringify({
    token: r
  });
  return (await Xt(je(Ke.refresh()), {
    body: e,
    method: "POST"
  })).body?.token;
}, ia = async () => {
  const r = Se.getToken();
  if (!r)
    return null;
  const e = JSON.stringify({
    access_token: r
  });
  return (await Xt(
    je(Ke.refreshGuestToken()),
    {
      body: e,
      method: "POST"
    }
  )).body?.access_token;
}, oa = async () => {
  const r = K.isSDK;
  try {
    const e = r ? await na() : await aa();
    K.setJwtToken(e), oe.persistToken(e);
  } catch {
    oe.removeToken();
  }
  try {
    const e = await ia();
    e && Se.persistToken(e);
  } catch (e) {
    e?.body?.detail !== "Token is not expired yet" && Se.removeToken();
  }
}, sa = Bn({
  shouldRefreshToken: ra,
  refreshToken: oa,
  fetch: ta
});
async function Re(r, e = {}) {
  const { externalURL: t, retryCount: n = 0 } = e;
  try {
    const a = t || je(r), { response: l, body: h } = await sa(a, e);
    return { body: h, headers: l.headers, response: l };
  } catch (a) {
    if ((hn(a) || gn(a)) && ea(e, a))
      return await Yn(Ln(n)), Re(r, {
        ...e,
        retryCount: n + 1
      });
    const l = Zn(
      a.response,
      a.body,
      a?.message
    );
    if (l)
      throw l;
    const h = a.body;
    throw h ?? (a instanceof Zt ? a : new Error(a?.message || "An unknown error occurred"));
  }
}
const y = {
  get: (r, e) => Re(r, {
    method: "GET",
    ...e
  }),
  post: (r, { body: e, json: t, ...n } = {}) => Re(r, {
    method: "POST",
    body: t ? JSON.stringify(t) : e,
    ...n
  }),
  put: (r, { body: e, json: t, ...n } = {}) => Re(r, {
    method: "PUT",
    body: t ? JSON.stringify(t) : e,
    ...n
  }),
  patch: (r, { body: e, json: t, ...n } = {}) => Re(r, {
    method: "PATCH",
    body: t ? JSON.stringify(t) : e,
    ...n
  }),
  delete: (r, { body: e, ...t } = {}) => Re(r, {
    method: "DELETE",
    ...t
  })
}, ne = class ne {
  async getAuthToken(e, t) {
    return (await y.post(
      ne.ENDPOINTS.apikeyAuth(),
      {
        json: e,
        publicAccess: !0,
        ...t
      }
    )).body;
  }
  getChekinToken({ token: e }, t) {
    return y.get(ne.ENDPOINTS.shortLink(e), {
      publicAccess: !0,
      ...t
    });
  }
  async fetchIpDetails(e) {
    return (await y.get(
      ne.ENDPOINTS.ipDetails(),
      e
    )).body;
  }
  async initiateUser(e, t) {
    return (await y.post(
      ne.ENDPOINTS.usersInitiate(),
      {
        json: e,
        publicAccess: !0,
        ...t
      }
    )).body;
  }
  async finalizeUser(e, t) {
    return (await y.post(
      ne.ENDPOINTS.usersFinalize(),
      {
        json: e,
        publicAccess: !0,
        ...t
      }
    )).body;
  }
  async getToken(e, t) {
    return (await y.post(
      ne.ENDPOINTS.guestToken(),
      { json: e, publicAccess: !0, ...t }
    )).body;
  }
  async getMe(e) {
    return (await y.get(
      ne.ENDPOINTS.me(),
      e
    )).body;
  }
  async getParticipants(e) {
    return (await y.get(
      ne.ENDPOINTS.participants(),
      e
    )).body;
  }
  async oauthGoogleCallback(e, t) {
    return (await y.post(
      ne.ENDPOINTS.googleCallback(),
      {
        json: e,
        publicAccess: !0,
        ...t
      }
    )).body;
  }
};
ne.ENDPOINTS = Ke;
let Ht = ne;
const _ = ({ regular: r, sdk: e }) => K.isSDK ? e : r;
class ca {
  constructor() {
    this.ENDPOINTS = {
      oneV4: (e, t = "") => _({
        regular: `api/v4/guestapp/guests/${e}/${t}`,
        sdk: `sdk/api/v1/guestapp/guests/${e}/${t}`
      }),
      getSchema: () => _({
        regular: "api/v4/guestapp/guests/schema/v2",
        sdk: "sdk/api/v1/guestapp/guests/schema/v2"
      }),
      delete: (e) => _({
        regular: `api/v3/guests/${e}/`,
        sdk: `sdk/api/v1/guests/${e}/`
      }),
      create: (e = "") => _({
        regular: `api/v4/guestapp/guests/${e}`,
        sdk: `sdk/api/v1/guestapp/guests/${e}`
      }),
      update: (e) => _({
        regular: `api/v4/guestapp/guests/${e}/`,
        sdk: `sdk/api/v1/guestapp/guests/${e}/`
      }),
      livenessDetection: () => "api/v3/guest-liveness-detection",
      searchForIV: () => "api/v3/guests-iv/search-guest",
      //   dynamicRoute({
      //   regular: `api/v3/guests-iv/search-guest/`,
      //   sdk: `sdk/api/v1/guests-iv/search-guest/`,
      // }),
      createGuestByParticipant: () => _({
        regular: "api/v4/guestapp/guests/create-from-participant/",
        sdk: "sdk/api/v1/guestapp/guests/create-from-participant/"
      })
    };
  }
  async getOne(e, t) {
    return (await y.get(this.ENDPOINTS.oneV4(e), {
      requireEncryption: !0,
      ...t
    })).body;
  }
  async create(e, t) {
    return (await y.post(this.ENDPOINTS.create(), {
      body: e,
      headers: {},
      ...t
    })).body;
  }
  async createGuestByParticipant(e, t) {
    return (await y.post(
      this.ENDPOINTS.createGuestByParticipant(),
      {
        json: e,
        ...t
      }
    )).body;
  }
  async createMin(e, t) {
    return (await y.post(this.ENDPOINTS.create("?min=true"), {
      json: e,
      ...t
    })).body;
  }
  async patch(e, t, n) {
    return (await y.patch(this.ENDPOINTS.update(e), {
      body: t,
      headers: {},
      ...n
    })).body;
  }
  async put(e, t, n) {
    return (await y.put(this.ENDPOINTS.update(e), {
      body: t,
      headers: {},
      ...n
    })).body;
  }
  async delete(e, t) {
    return (await y.delete(this.ENDPOINTS.delete(e), t)).body;
  }
  async getSchema(e, t) {
    return (await y.post(this.ENDPOINTS.getSchema(), {
      json: e,
      ...t
    })).body;
  }
  async livenessDetection(e, t) {
    return (await y.post(
      this.ENDPOINTS.livenessDetection(),
      {
        json: e,
        ...t
      }
    )).body;
  }
  async searchForIV(e, t) {
    const n = new URLSearchParams({
      housing_id: e.housing_id,
      name: e.name,
      surname: e.surname,
      ...e.id_number && { id_number: e.id_number },
      ...e.date_of_birth && { date_of_birth: e.date_of_birth },
      ...e.checkout_date && { checkout_date: e.checkout_date }
    }).toString();
    return (await y.get(
      `${this.ENDPOINTS.searchForIV()}?${n}`,
      t
    )).body;
  }
}
class vn {
  constructor() {
    this.ENDPOINTS = {
      phoneNumber: () => "api/v3/validators/phone-number"
    };
  }
  async validatePhoneNumber(e, t) {
    return (await y.post(this.ENDPOINTS.phoneNumber(), {
      json: e,
      ...t
    })).body;
  }
}
var dr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ua(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function la(r) {
  if (Object.prototype.hasOwnProperty.call(r, "__esModule")) return r;
  var e = r.default;
  if (typeof e == "function") {
    var t = function n() {
      var a = !1;
      try {
        a = this instanceof n;
      } catch {
      }
      return a ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(r).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(r, n);
    Object.defineProperty(t, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return r[n];
      }
    });
  }), t;
}
var et, hr;
function $e() {
  return hr || (hr = 1, et = TypeError), et;
}
const pa = {}, fa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pa
}, Symbol.toStringTag, { value: "Module" })), ya = /* @__PURE__ */ la(fa);
var tt, gr;
function We() {
  if (gr) return tt;
  gr = 1;
  var r = typeof Map == "function" && Map.prototype, e = Object.getOwnPropertyDescriptor && r ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, t = r && e && typeof e.get == "function" ? e.get : null, n = r && Map.prototype.forEach, a = typeof Set == "function" && Set.prototype, l = Object.getOwnPropertyDescriptor && a ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, h = a && l && typeof l.get == "function" ? l.get : null, f = a && Set.prototype.forEach, S = typeof WeakMap == "function" && WeakMap.prototype, v = S ? WeakMap.prototype.has : null, b = typeof WeakSet == "function" && WeakSet.prototype, k = b ? WeakSet.prototype.has : null, g = typeof WeakRef == "function" && WeakRef.prototype, p = g ? WeakRef.prototype.deref : null, d = Boolean.prototype.valueOf, T = Object.prototype.toString, s = Function.prototype.toString, c = String.prototype.match, u = String.prototype.slice, w = String.prototype.replace, m = String.prototype.toUpperCase, O = String.prototype.toLowerCase, P = RegExp.prototype.test, N = Array.prototype.concat, I = Array.prototype.join, B = Array.prototype.slice, $ = Math.floor, G = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, E = Object.getOwnPropertySymbols, H = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, W = typeof Symbol == "function" && typeof Symbol.iterator == "object", Z = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === W || !0) ? Symbol.toStringTag : null, se = Object.prototype.propertyIsEnumerable, ce = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(i) {
    return i.__proto__;
  } : null);
  function C(i, o) {
    if (i === 1 / 0 || i === -1 / 0 || i !== i || i && i > -1e3 && i < 1e3 || P.call(/e/, o))
      return o;
    var q = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof i == "number") {
      var A = i < 0 ? -$(-i) : $(i);
      if (A !== i) {
        var F = String(A), x = u.call(o, F.length + 1);
        return w.call(F, q, "$&_") + "." + w.call(w.call(x, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return w.call(o, q, "$&_");
  }
  var L = ya, ue = L.custom, be = z(ue) ? ue : null, pe = {
    __proto__: null,
    double: '"',
    single: "'"
  }, fe = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  tt = function i(o, q, A, F) {
    var x = q || {};
    if (X(x, "quoteStyle") && !X(pe, x.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (X(x, "maxStringLength") && (typeof x.maxStringLength == "number" ? x.maxStringLength < 0 && x.maxStringLength !== 1 / 0 : x.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var ve = X(x, "customInspect") ? x.customInspect : !0;
    if (typeof ve != "boolean" && ve !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (X(x, "indent") && x.indent !== null && x.indent !== "	" && !(parseInt(x.indent, 10) === x.indent && x.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (X(x, "numericSeparator") && typeof x.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var we = x.numericSeparator;
    if (typeof o > "u")
      return "undefined";
    if (o === null)
      return "null";
    if (typeof o == "boolean")
      return o ? "true" : "false";
    if (typeof o == "string")
      return ar(o, x);
    if (typeof o == "number") {
      if (o === 0)
        return 1 / 0 / o > 0 ? "0" : "-0";
      var Y = String(o);
      return we ? C(o, Y) : Y;
    }
    if (typeof o == "bigint") {
      var me = String(o) + "n";
      return we ? C(o, me) : me;
    }
    var ze = typeof x.depth > "u" ? 5 : x.depth;
    if (typeof A > "u" && (A = 0), A >= ze && ze > 0 && typeof o == "object")
      return de(o) ? "[Array]" : "[Object]";
    var Ee = $n(x, A);
    if (typeof F > "u")
      F = [];
    else if (ge(F, o) >= 0)
      return "[Circular]";
    function ie(_e, Ge, Cn) {
      if (Ge && (F = B.call(F), F.push(Ge)), Cn) {
        var yr = {
          depth: x.depth
        };
        return X(x, "quoteStyle") && (yr.quoteStyle = x.quoteStyle), i(_e, yr, A + 1, F);
      }
      return i(_e, x, A + 1, F);
    }
    if (typeof o == "function" && !V(o)) {
      var or = Te(o), sr = qe(o, ie);
      return "[Function" + (or ? ": " + or : " (anonymous)") + "]" + (sr.length > 0 ? " { " + I.call(sr, ", ") + " }" : "");
    }
    if (z(o)) {
      var cr = W ? w.call(String(o), /^(Symbol\(.*\))_[^)]*$/, "$1") : H.call(o);
      return typeof o == "object" && !W ? xe(cr) : cr;
    }
    if (_n(o)) {
      for (var Ce = "<" + O.call(String(o.nodeName)), Je = o.attributes || [], Be = 0; Be < Je.length; Be++)
        Ce += " " + Je[Be].name + "=" + ye(le(Je[Be].value), "double", x);
      return Ce += ">", o.childNodes && o.childNodes.length && (Ce += "..."), Ce += "</" + O.call(String(o.nodeName)) + ">", Ce;
    }
    if (de(o)) {
      if (o.length === 0)
        return "[]";
      var Qe = qe(o, ie);
      return Ee && !In(Qe) ? "[" + He(Qe, Ee) + "]" : "[ " + I.call(Qe, ", ") + " ]";
    }
    if (D(o)) {
      var Xe = qe(o, ie);
      return !("cause" in Error.prototype) && "cause" in o && !se.call(o, "cause") ? "{ [" + String(o) + "] " + I.call(N.call("[cause]: " + ie(o.cause), Xe), ", ") + " }" : Xe.length === 0 ? "[" + String(o) + "]" : "{ [" + String(o) + "] " + I.call(Xe, ", ") + " }";
    }
    if (typeof o == "object" && ve) {
      if (be && typeof o[be] == "function" && L)
        return L(o, { depth: ze - A });
      if (ve !== "symbol" && typeof o.inspect == "function")
        return o.inspect();
    }
    if (ae(o)) {
      var ur = [];
      return n && n.call(o, function(_e, Ge) {
        ur.push(ie(Ge, o, !0) + " => " + ie(_e, o));
      }), ir("Map", t.call(o), ur, Ee);
    }
    if (Ne(o)) {
      var lr = [];
      return f && f.call(o, function(_e) {
        lr.push(ie(_e, o));
      }), ir("Set", h.call(o), lr, Ee);
    }
    if (Oe(o))
      return Ve("WeakMap");
    if (En(o))
      return Ve("WeakSet");
    if (Pe(o))
      return Ve("WeakRef");
    if (U(o))
      return xe(ie(Number(o)));
    if (te(o))
      return xe(ie(G.call(o)));
    if (M(o))
      return xe(d.call(o));
    if (j(o))
      return xe(ie(String(o)));
    if (typeof window < "u" && o === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && o === globalThis || typeof dr < "u" && o === dr)
      return "{ [object globalThis] }";
    if (!he(o) && !V(o)) {
      var Ze = qe(o, ie), pr = ce ? ce(o) === Object.prototype : o instanceof Object || o.constructor === Object, Le = o instanceof Object ? "" : "null prototype", fr = !pr && Z && Object(o) === o && Z in o ? u.call(re(o), 8, -1) : Le ? "Object" : "", xn = pr || typeof o.constructor != "function" ? "" : o.constructor.name ? o.constructor.name + " " : "", Ye = xn + (fr || Le ? "[" + I.call(N.call([], fr || [], Le || []), ": ") + "] " : "");
      return Ze.length === 0 ? Ye + "{}" : Ee ? Ye + "{" + He(Ze, Ee) + "}" : Ye + "{ " + I.call(Ze, ", ") + " }";
    }
    return String(o);
  };
  function ye(i, o, q) {
    var A = q.quoteStyle || o, F = pe[A];
    return F + i + F;
  }
  function le(i) {
    return w.call(String(i), /"/g, "&quot;");
  }
  function ee(i) {
    return !Z || !(typeof i == "object" && (Z in i || typeof i[Z] < "u"));
  }
  function de(i) {
    return re(i) === "[object Array]" && ee(i);
  }
  function he(i) {
    return re(i) === "[object Date]" && ee(i);
  }
  function V(i) {
    return re(i) === "[object RegExp]" && ee(i);
  }
  function D(i) {
    return re(i) === "[object Error]" && ee(i);
  }
  function j(i) {
    return re(i) === "[object String]" && ee(i);
  }
  function U(i) {
    return re(i) === "[object Number]" && ee(i);
  }
  function M(i) {
    return re(i) === "[object Boolean]" && ee(i);
  }
  function z(i) {
    if (W)
      return i && typeof i == "object" && i instanceof Symbol;
    if (typeof i == "symbol")
      return !0;
    if (!i || typeof i != "object" || !H)
      return !1;
    try {
      return H.call(i), !0;
    } catch {
    }
    return !1;
  }
  function te(i) {
    if (!i || typeof i != "object" || !G)
      return !1;
    try {
      return G.call(i), !0;
    } catch {
    }
    return !1;
  }
  var J = Object.prototype.hasOwnProperty || function(i) {
    return i in this;
  };
  function X(i, o) {
    return J.call(i, o);
  }
  function re(i) {
    return T.call(i);
  }
  function Te(i) {
    if (i.name)
      return i.name;
    var o = c.call(s.call(i), /^function\s*([\w$]+)/);
    return o ? o[1] : null;
  }
  function ge(i, o) {
    if (i.indexOf)
      return i.indexOf(o);
    for (var q = 0, A = i.length; q < A; q++)
      if (i[q] === o)
        return q;
    return -1;
  }
  function ae(i) {
    if (!t || !i || typeof i != "object")
      return !1;
    try {
      t.call(i);
      try {
        h.call(i);
      } catch {
        return !0;
      }
      return i instanceof Map;
    } catch {
    }
    return !1;
  }
  function Oe(i) {
    if (!v || !i || typeof i != "object")
      return !1;
    try {
      v.call(i, v);
      try {
        k.call(i, k);
      } catch {
        return !0;
      }
      return i instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function Pe(i) {
    if (!p || !i || typeof i != "object")
      return !1;
    try {
      return p.call(i), !0;
    } catch {
    }
    return !1;
  }
  function Ne(i) {
    if (!h || !i || typeof i != "object")
      return !1;
    try {
      h.call(i);
      try {
        t.call(i);
      } catch {
        return !0;
      }
      return i instanceof Set;
    } catch {
    }
    return !1;
  }
  function En(i) {
    if (!k || !i || typeof i != "object")
      return !1;
    try {
      k.call(i, k);
      try {
        v.call(i, v);
      } catch {
        return !0;
      }
      return i instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function _n(i) {
    return !i || typeof i != "object" ? !1 : typeof HTMLElement < "u" && i instanceof HTMLElement ? !0 : typeof i.nodeName == "string" && typeof i.getAttribute == "function";
  }
  function ar(i, o) {
    if (i.length > o.maxStringLength) {
      var q = i.length - o.maxStringLength, A = "... " + q + " more character" + (q > 1 ? "s" : "");
      return ar(u.call(i, 0, o.maxStringLength), o) + A;
    }
    var F = fe[o.quoteStyle || "single"];
    F.lastIndex = 0;
    var x = w.call(w.call(i, F, "\\$1"), /[\x00-\x1f]/g, Rn);
    return ye(x, "single", o);
  }
  function Rn(i) {
    var o = i.charCodeAt(0), q = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[o];
    return q ? "\\" + q : "\\x" + (o < 16 ? "0" : "") + m.call(o.toString(16));
  }
  function xe(i) {
    return "Object(" + i + ")";
  }
  function Ve(i) {
    return i + " { ? }";
  }
  function ir(i, o, q, A) {
    var F = A ? He(q, A) : I.call(q, ", ");
    return i + " (" + o + ") {" + F + "}";
  }
  function In(i) {
    for (var o = 0; o < i.length; o++)
      if (ge(i[o], `
`) >= 0)
        return !1;
    return !0;
  }
  function $n(i, o) {
    var q;
    if (i.indent === "	")
      q = "	";
    else if (typeof i.indent == "number" && i.indent > 0)
      q = I.call(Array(i.indent + 1), " ");
    else
      return null;
    return {
      base: q,
      prev: I.call(Array(o + 1), q)
    };
  }
  function He(i, o) {
    if (i.length === 0)
      return "";
    var q = `
` + o.prev + o.base;
    return q + I.call(i, "," + q) + `
` + o.prev;
  }
  function qe(i, o) {
    var q = de(i), A = [];
    if (q) {
      A.length = i.length;
      for (var F = 0; F < i.length; F++)
        A[F] = X(i, F) ? o(i[F], i) : "";
    }
    var x = typeof E == "function" ? E(i) : [], ve;
    if (W) {
      ve = {};
      for (var we = 0; we < x.length; we++)
        ve["$" + x[we]] = x[we];
    }
    for (var Y in i)
      X(i, Y) && (q && String(Number(Y)) === Y && Y < i.length || W && ve["$" + Y] instanceof Symbol || (P.call(/[^\w$]/, Y) ? A.push(o(Y, i) + ": " + o(i[Y], i)) : A.push(Y + ": " + o(i[Y], i))));
    if (typeof E == "function")
      for (var me = 0; me < x.length; me++)
        se.call(i, x[me]) && A.push("[" + o(x[me]) + "]: " + o(i[x[me]], i));
    return A;
  }
  return tt;
}
var rt, vr;
function da() {
  if (vr) return rt;
  vr = 1;
  var r = /* @__PURE__ */ We(), e = /* @__PURE__ */ $e(), t = function(f, S, v) {
    for (var b = f, k; (k = b.next) != null; b = k)
      if (k.key === S)
        return b.next = k.next, v || (k.next = /** @type {NonNullable<typeof list.next>} */
        f.next, f.next = k), k;
  }, n = function(f, S) {
    if (f) {
      var v = t(f, S);
      return v && v.value;
    }
  }, a = function(f, S, v) {
    var b = t(f, S);
    b ? b.value = v : f.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: S,
      next: f.next,
      value: v
    };
  }, l = function(f, S) {
    return f ? !!t(f, S) : !1;
  }, h = function(f, S) {
    if (f)
      return t(f, S, !0);
  };
  return rt = function() {
    var S, v = {
      assert: function(b) {
        if (!v.has(b))
          throw new e("Side channel does not contain " + r(b));
      },
      delete: function(b) {
        var k = S && S.next, g = h(S, b);
        return g && k && k === g && (S = void 0), !!g;
      },
      get: function(b) {
        return n(S, b);
      },
      has: function(b) {
        return l(S, b);
      },
      set: function(b, k) {
        S || (S = {
          next: void 0
        }), a(
          /** @type {NonNullable<typeof $o>} */
          S,
          b,
          k
        );
      }
    };
    return v;
  }, rt;
}
var nt, mr;
function mn() {
  return mr || (mr = 1, nt = Object), nt;
}
var at, br;
function ha() {
  return br || (br = 1, at = Error), at;
}
var it, wr;
function ga() {
  return wr || (wr = 1, it = EvalError), it;
}
var ot, kr;
function va() {
  return kr || (kr = 1, ot = RangeError), ot;
}
var st, Sr;
function ma() {
  return Sr || (Sr = 1, st = ReferenceError), st;
}
var ct, Tr;
function ba() {
  return Tr || (Tr = 1, ct = SyntaxError), ct;
}
var ut, Or;
function wa() {
  return Or || (Or = 1, ut = URIError), ut;
}
var lt, Pr;
function ka() {
  return Pr || (Pr = 1, lt = Math.abs), lt;
}
var pt, Nr;
function Sa() {
  return Nr || (Nr = 1, pt = Math.floor), pt;
}
var ft, Er;
function Ta() {
  return Er || (Er = 1, ft = Math.max), ft;
}
var yt, _r;
function Oa() {
  return _r || (_r = 1, yt = Math.min), yt;
}
var dt, Rr;
function Pa() {
  return Rr || (Rr = 1, dt = Math.pow), dt;
}
var ht, Ir;
function Na() {
  return Ir || (Ir = 1, ht = Math.round), ht;
}
var gt, $r;
function Ea() {
  return $r || ($r = 1, gt = Number.isNaN || function(e) {
    return e !== e;
  }), gt;
}
var vt, xr;
function _a() {
  if (xr) return vt;
  xr = 1;
  var r = /* @__PURE__ */ Ea();
  return vt = function(t) {
    return r(t) || t === 0 ? t : t < 0 ? -1 : 1;
  }, vt;
}
var mt, Cr;
function Ra() {
  return Cr || (Cr = 1, mt = Object.getOwnPropertyDescriptor), mt;
}
var bt, Dr;
function bn() {
  if (Dr) return bt;
  Dr = 1;
  var r = /* @__PURE__ */ Ra();
  if (r)
    try {
      r([], "length");
    } catch {
      r = null;
    }
  return bt = r, bt;
}
var wt, qr;
function Ia() {
  if (qr) return wt;
  qr = 1;
  var r = Object.defineProperty || !1;
  if (r)
    try {
      r({}, "a", { value: 1 });
    } catch {
      r = !1;
    }
  return wt = r, wt;
}
var kt, Br;
function $a() {
  return Br || (Br = 1, kt = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var e = {}, t = Symbol("test"), n = Object(t);
    if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var a = 42;
    e[t] = a;
    for (var l in e)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
      return !1;
    var h = Object.getOwnPropertySymbols(e);
    if (h.length !== 1 || h[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var f = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(e, t)
      );
      if (f.value !== a || f.enumerable !== !0)
        return !1;
    }
    return !0;
  }), kt;
}
var St, Gr;
function xa() {
  if (Gr) return St;
  Gr = 1;
  var r = typeof Symbol < "u" && Symbol, e = $a();
  return St = function() {
    return typeof r != "function" || typeof Symbol != "function" || typeof r("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
  }, St;
}
var Tt, Ur;
function wn() {
  return Ur || (Ur = 1, Tt = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Tt;
}
var Ot, Ar;
function kn() {
  if (Ar) return Ot;
  Ar = 1;
  var r = /* @__PURE__ */ mn();
  return Ot = r.getPrototypeOf || null, Ot;
}
var Pt, Fr;
function Ca() {
  if (Fr) return Pt;
  Fr = 1;
  var r = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, t = Math.max, n = "[object Function]", a = function(S, v) {
    for (var b = [], k = 0; k < S.length; k += 1)
      b[k] = S[k];
    for (var g = 0; g < v.length; g += 1)
      b[g + S.length] = v[g];
    return b;
  }, l = function(S, v) {
    for (var b = [], k = v, g = 0; k < S.length; k += 1, g += 1)
      b[g] = S[k];
    return b;
  }, h = function(f, S) {
    for (var v = "", b = 0; b < f.length; b += 1)
      v += f[b], b + 1 < f.length && (v += S);
    return v;
  };
  return Pt = function(S) {
    var v = this;
    if (typeof v != "function" || e.apply(v) !== n)
      throw new TypeError(r + v);
    for (var b = l(arguments, 1), k, g = function() {
      if (this instanceof k) {
        var c = v.apply(
          this,
          a(b, arguments)
        );
        return Object(c) === c ? c : this;
      }
      return v.apply(
        S,
        a(b, arguments)
      );
    }, p = t(0, v.length - b.length), d = [], T = 0; T < p; T++)
      d[T] = "$" + T;
    if (k = Function("binder", "return function (" + h(d, ",") + "){ return binder.apply(this,arguments); }")(g), v.prototype) {
      var s = function() {
      };
      s.prototype = v.prototype, k.prototype = new s(), s.prototype = null;
    }
    return k;
  }, Pt;
}
var Nt, Kr;
function Me() {
  if (Kr) return Nt;
  Kr = 1;
  var r = Ca();
  return Nt = Function.prototype.bind || r, Nt;
}
var Et, jr;
function Yt() {
  return jr || (jr = 1, Et = Function.prototype.call), Et;
}
var _t, Wr;
function Sn() {
  return Wr || (Wr = 1, _t = Function.prototype.apply), _t;
}
var Rt, Mr;
function Da() {
  return Mr || (Mr = 1, Rt = typeof Reflect < "u" && Reflect && Reflect.apply), Rt;
}
var It, Vr;
function qa() {
  if (Vr) return It;
  Vr = 1;
  var r = Me(), e = Sn(), t = Yt(), n = Da();
  return It = n || r.call(t, e), It;
}
var $t, Hr;
function Tn() {
  if (Hr) return $t;
  Hr = 1;
  var r = Me(), e = /* @__PURE__ */ $e(), t = Yt(), n = qa();
  return $t = function(l) {
    if (l.length < 1 || typeof l[0] != "function")
      throw new e("a function is required");
    return n(r, t, l);
  }, $t;
}
var xt, zr;
function Ba() {
  if (zr) return xt;
  zr = 1;
  var r = Tn(), e = /* @__PURE__ */ bn(), t;
  try {
    t = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (h) {
    if (!h || typeof h != "object" || !("code" in h) || h.code !== "ERR_PROTO_ACCESS")
      throw h;
  }
  var n = !!t && e && e(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), a = Object, l = a.getPrototypeOf;
  return xt = n && typeof n.get == "function" ? r([n.get]) : typeof l == "function" ? (
    /** @type {import('./get')} */
    function(f) {
      return l(f == null ? f : a(f));
    }
  ) : !1, xt;
}
var Ct, Jr;
function Ga() {
  if (Jr) return Ct;
  Jr = 1;
  var r = wn(), e = kn(), t = /* @__PURE__ */ Ba();
  return Ct = r ? function(a) {
    return r(a);
  } : e ? function(a) {
    if (!a || typeof a != "object" && typeof a != "function")
      throw new TypeError("getProto: not an object");
    return e(a);
  } : t ? function(a) {
    return t(a);
  } : null, Ct;
}
var Dt, Qr;
function Ua() {
  if (Qr) return Dt;
  Qr = 1;
  var r = Function.prototype.call, e = Object.prototype.hasOwnProperty, t = Me();
  return Dt = t.call(r, e), Dt;
}
var qt, Xr;
function er() {
  if (Xr) return qt;
  Xr = 1;
  var r, e = /* @__PURE__ */ mn(), t = /* @__PURE__ */ ha(), n = /* @__PURE__ */ ga(), a = /* @__PURE__ */ va(), l = /* @__PURE__ */ ma(), h = /* @__PURE__ */ ba(), f = /* @__PURE__ */ $e(), S = /* @__PURE__ */ wa(), v = /* @__PURE__ */ ka(), b = /* @__PURE__ */ Sa(), k = /* @__PURE__ */ Ta(), g = /* @__PURE__ */ Oa(), p = /* @__PURE__ */ Pa(), d = /* @__PURE__ */ Na(), T = /* @__PURE__ */ _a(), s = Function, c = function(V) {
    try {
      return s('"use strict"; return (' + V + ").constructor;")();
    } catch {
    }
  }, u = /* @__PURE__ */ bn(), w = /* @__PURE__ */ Ia(), m = function() {
    throw new f();
  }, O = u ? (function() {
    try {
      return arguments.callee, m;
    } catch {
      try {
        return u(arguments, "callee").get;
      } catch {
        return m;
      }
    }
  })() : m, P = xa()(), N = Ga(), I = kn(), B = wn(), $ = Sn(), G = Yt(), E = {}, H = typeof Uint8Array > "u" || !N ? r : N(Uint8Array), W = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? r : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? r : ArrayBuffer,
    "%ArrayIteratorPrototype%": P && N ? N([][Symbol.iterator]()) : r,
    "%AsyncFromSyncIteratorPrototype%": r,
    "%AsyncFunction%": E,
    "%AsyncGenerator%": E,
    "%AsyncGeneratorFunction%": E,
    "%AsyncIteratorPrototype%": E,
    "%Atomics%": typeof Atomics > "u" ? r : Atomics,
    "%BigInt%": typeof BigInt > "u" ? r : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? r : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? r : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? r : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": t,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float16Array%": typeof Float16Array > "u" ? r : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? r : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? r : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? r : FinalizationRegistry,
    "%Function%": s,
    "%GeneratorFunction%": E,
    "%Int8Array%": typeof Int8Array > "u" ? r : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? r : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? r : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": P && N ? N(N([][Symbol.iterator]())) : r,
    "%JSON%": typeof JSON == "object" ? JSON : r,
    "%Map%": typeof Map > "u" ? r : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !P || !N ? r : N((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": e,
    "%Object.getOwnPropertyDescriptor%": u,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? r : Promise,
    "%Proxy%": typeof Proxy > "u" ? r : Proxy,
    "%RangeError%": a,
    "%ReferenceError%": l,
    "%Reflect%": typeof Reflect > "u" ? r : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? r : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !P || !N ? r : N((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? r : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": P && N ? N(""[Symbol.iterator]()) : r,
    "%Symbol%": P ? Symbol : r,
    "%SyntaxError%": h,
    "%ThrowTypeError%": O,
    "%TypedArray%": H,
    "%TypeError%": f,
    "%Uint8Array%": typeof Uint8Array > "u" ? r : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? r : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? r : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? r : Uint32Array,
    "%URIError%": S,
    "%WeakMap%": typeof WeakMap > "u" ? r : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? r : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? r : WeakSet,
    "%Function.prototype.call%": G,
    "%Function.prototype.apply%": $,
    "%Object.defineProperty%": w,
    "%Object.getPrototypeOf%": I,
    "%Math.abs%": v,
    "%Math.floor%": b,
    "%Math.max%": k,
    "%Math.min%": g,
    "%Math.pow%": p,
    "%Math.round%": d,
    "%Math.sign%": T,
    "%Reflect.getPrototypeOf%": B
  };
  if (N)
    try {
      null.error;
    } catch (V) {
      var Z = N(N(V));
      W["%Error.prototype%"] = Z;
    }
  var se = function V(D) {
    var j;
    if (D === "%AsyncFunction%")
      j = c("async function () {}");
    else if (D === "%GeneratorFunction%")
      j = c("function* () {}");
    else if (D === "%AsyncGeneratorFunction%")
      j = c("async function* () {}");
    else if (D === "%AsyncGenerator%") {
      var U = V("%AsyncGeneratorFunction%");
      U && (j = U.prototype);
    } else if (D === "%AsyncIteratorPrototype%") {
      var M = V("%AsyncGenerator%");
      M && N && (j = N(M.prototype));
    }
    return W[D] = j, j;
  }, ce = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, C = Me(), L = /* @__PURE__ */ Ua(), ue = C.call(G, Array.prototype.concat), be = C.call($, Array.prototype.splice), pe = C.call(G, String.prototype.replace), fe = C.call(G, String.prototype.slice), ye = C.call(G, RegExp.prototype.exec), le = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, ee = /\\(\\)?/g, de = function(D) {
    var j = fe(D, 0, 1), U = fe(D, -1);
    if (j === "%" && U !== "%")
      throw new h("invalid intrinsic syntax, expected closing `%`");
    if (U === "%" && j !== "%")
      throw new h("invalid intrinsic syntax, expected opening `%`");
    var M = [];
    return pe(D, le, function(z, te, J, X) {
      M[M.length] = J ? pe(X, ee, "$1") : te || z;
    }), M;
  }, he = function(D, j) {
    var U = D, M;
    if (L(ce, U) && (M = ce[U], U = "%" + M[0] + "%"), L(W, U)) {
      var z = W[U];
      if (z === E && (z = se(U)), typeof z > "u" && !j)
        throw new f("intrinsic " + D + " exists, but is not available. Please file an issue!");
      return {
        alias: M,
        name: U,
        value: z
      };
    }
    throw new h("intrinsic " + D + " does not exist!");
  };
  return qt = function(D, j) {
    if (typeof D != "string" || D.length === 0)
      throw new f("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof j != "boolean")
      throw new f('"allowMissing" argument must be a boolean');
    if (ye(/^%?[^%]*%?$/, D) === null)
      throw new h("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var U = de(D), M = U.length > 0 ? U[0] : "", z = he("%" + M + "%", j), te = z.name, J = z.value, X = !1, re = z.alias;
    re && (M = re[0], be(U, ue([0, 1], re)));
    for (var Te = 1, ge = !0; Te < U.length; Te += 1) {
      var ae = U[Te], Oe = fe(ae, 0, 1), Pe = fe(ae, -1);
      if ((Oe === '"' || Oe === "'" || Oe === "`" || Pe === '"' || Pe === "'" || Pe === "`") && Oe !== Pe)
        throw new h("property names with quotes must have matching quotes");
      if ((ae === "constructor" || !ge) && (X = !0), M += "." + ae, te = "%" + M + "%", L(W, te))
        J = W[te];
      else if (J != null) {
        if (!(ae in J)) {
          if (!j)
            throw new f("base intrinsic for " + D + " exists, but the property is not available.");
          return;
        }
        if (u && Te + 1 >= U.length) {
          var Ne = u(J, ae);
          ge = !!Ne, ge && "get" in Ne && !("originalValue" in Ne.get) ? J = Ne.get : J = J[ae];
        } else
          ge = L(J, ae), J = J[ae];
        ge && !X && (W[te] = J);
      }
    }
    return J;
  }, qt;
}
var Bt, Zr;
function On() {
  if (Zr) return Bt;
  Zr = 1;
  var r = /* @__PURE__ */ er(), e = Tn(), t = e([r("%String.prototype.indexOf%")]);
  return Bt = function(a, l) {
    var h = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      r(a, !!l)
    );
    return typeof h == "function" && t(a, ".prototype.") > -1 ? e(
      /** @type {const} */
      [h]
    ) : h;
  }, Bt;
}
var Gt, Lr;
function Pn() {
  if (Lr) return Gt;
  Lr = 1;
  var r = /* @__PURE__ */ er(), e = /* @__PURE__ */ On(), t = /* @__PURE__ */ We(), n = /* @__PURE__ */ $e(), a = r("%Map%", !0), l = e("Map.prototype.get", !0), h = e("Map.prototype.set", !0), f = e("Map.prototype.has", !0), S = e("Map.prototype.delete", !0), v = e("Map.prototype.size", !0);
  return Gt = !!a && /** @type {Exclude<import('.'), false>} */
  function() {
    var k, g = {
      assert: function(p) {
        if (!g.has(p))
          throw new n("Side channel does not contain " + t(p));
      },
      delete: function(p) {
        if (k) {
          var d = S(k, p);
          return v(k) === 0 && (k = void 0), d;
        }
        return !1;
      },
      get: function(p) {
        if (k)
          return l(k, p);
      },
      has: function(p) {
        return k ? f(k, p) : !1;
      },
      set: function(p, d) {
        k || (k = new a()), h(k, p, d);
      }
    };
    return g;
  }, Gt;
}
var Ut, Yr;
function Aa() {
  if (Yr) return Ut;
  Yr = 1;
  var r = /* @__PURE__ */ er(), e = /* @__PURE__ */ On(), t = /* @__PURE__ */ We(), n = Pn(), a = /* @__PURE__ */ $e(), l = r("%WeakMap%", !0), h = e("WeakMap.prototype.get", !0), f = e("WeakMap.prototype.set", !0), S = e("WeakMap.prototype.has", !0), v = e("WeakMap.prototype.delete", !0);
  return Ut = l ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var k, g, p = {
        assert: function(d) {
          if (!p.has(d))
            throw new a("Side channel does not contain " + t(d));
        },
        delete: function(d) {
          if (l && d && (typeof d == "object" || typeof d == "function")) {
            if (k)
              return v(k, d);
          } else if (n && g)
            return g.delete(d);
          return !1;
        },
        get: function(d) {
          return l && d && (typeof d == "object" || typeof d == "function") && k ? h(k, d) : g && g.get(d);
        },
        has: function(d) {
          return l && d && (typeof d == "object" || typeof d == "function") && k ? S(k, d) : !!g && g.has(d);
        },
        set: function(d, T) {
          l && d && (typeof d == "object" || typeof d == "function") ? (k || (k = new l()), f(k, d, T)) : n && (g || (g = n()), g.set(d, T));
        }
      };
      return p;
    }
  ) : n, Ut;
}
var At, en;
function Fa() {
  if (en) return At;
  en = 1;
  var r = /* @__PURE__ */ $e(), e = /* @__PURE__ */ We(), t = da(), n = Pn(), a = Aa(), l = a || n || t;
  return At = function() {
    var f, S = {
      assert: function(v) {
        if (!S.has(v))
          throw new r("Side channel does not contain " + e(v));
      },
      delete: function(v) {
        return !!f && f.delete(v);
      },
      get: function(v) {
        return f && f.get(v);
      },
      has: function(v) {
        return !!f && f.has(v);
      },
      set: function(v, b) {
        f || (f = l()), f.set(v, b);
      }
    };
    return S;
  }, At;
}
var Ft, tn;
function tr() {
  if (tn) return Ft;
  tn = 1;
  var r = String.prototype.replace, e = /%20/g, t = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return Ft = {
    default: t.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return r.call(n, e, "+");
      },
      RFC3986: function(n) {
        return String(n);
      }
    },
    RFC1738: t.RFC1738,
    RFC3986: t.RFC3986
  }, Ft;
}
var Kt, rn;
function Nn() {
  if (rn) return Kt;
  rn = 1;
  var r = /* @__PURE__ */ tr(), e = Object.prototype.hasOwnProperty, t = Array.isArray, n = (function() {
    for (var s = [], c = 0; c < 256; ++c)
      s.push("%" + ((c < 16 ? "0" : "") + c.toString(16)).toUpperCase());
    return s;
  })(), a = function(c) {
    for (; c.length > 1; ) {
      var u = c.pop(), w = u.obj[u.prop];
      if (t(w)) {
        for (var m = [], O = 0; O < w.length; ++O)
          typeof w[O] < "u" && m.push(w[O]);
        u.obj[u.prop] = m;
      }
    }
  }, l = function(c, u) {
    for (var w = u && u.plainObjects ? { __proto__: null } : {}, m = 0; m < c.length; ++m)
      typeof c[m] < "u" && (w[m] = c[m]);
    return w;
  }, h = function s(c, u, w) {
    if (!u)
      return c;
    if (typeof u != "object" && typeof u != "function") {
      if (t(c))
        c.push(u);
      else if (c && typeof c == "object")
        (w && (w.plainObjects || w.allowPrototypes) || !e.call(Object.prototype, u)) && (c[u] = !0);
      else
        return [c, u];
      return c;
    }
    if (!c || typeof c != "object")
      return [c].concat(u);
    var m = c;
    return t(c) && !t(u) && (m = l(c, w)), t(c) && t(u) ? (u.forEach(function(O, P) {
      if (e.call(c, P)) {
        var N = c[P];
        N && typeof N == "object" && O && typeof O == "object" ? c[P] = s(N, O, w) : c.push(O);
      } else
        c[P] = O;
    }), c) : Object.keys(u).reduce(function(O, P) {
      var N = u[P];
      return e.call(O, P) ? O[P] = s(O[P], N, w) : O[P] = N, O;
    }, m);
  }, f = function(c, u) {
    return Object.keys(u).reduce(function(w, m) {
      return w[m] = u[m], w;
    }, c);
  }, S = function(s, c, u) {
    var w = s.replace(/\+/g, " ");
    if (u === "iso-8859-1")
      return w.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(w);
    } catch {
      return w;
    }
  }, v = 1024, b = function(c, u, w, m, O) {
    if (c.length === 0)
      return c;
    var P = c;
    if (typeof c == "symbol" ? P = Symbol.prototype.toString.call(c) : typeof c != "string" && (P = String(c)), w === "iso-8859-1")
      return escape(P).replace(/%u[0-9a-f]{4}/gi, function(H) {
        return "%26%23" + parseInt(H.slice(2), 16) + "%3B";
      });
    for (var N = "", I = 0; I < P.length; I += v) {
      for (var B = P.length >= v ? P.slice(I, I + v) : P, $ = [], G = 0; G < B.length; ++G) {
        var E = B.charCodeAt(G);
        if (E === 45 || E === 46 || E === 95 || E === 126 || E >= 48 && E <= 57 || E >= 65 && E <= 90 || E >= 97 && E <= 122 || O === r.RFC1738 && (E === 40 || E === 41)) {
          $[$.length] = B.charAt(G);
          continue;
        }
        if (E < 128) {
          $[$.length] = n[E];
          continue;
        }
        if (E < 2048) {
          $[$.length] = n[192 | E >> 6] + n[128 | E & 63];
          continue;
        }
        if (E < 55296 || E >= 57344) {
          $[$.length] = n[224 | E >> 12] + n[128 | E >> 6 & 63] + n[128 | E & 63];
          continue;
        }
        G += 1, E = 65536 + ((E & 1023) << 10 | B.charCodeAt(G) & 1023), $[$.length] = n[240 | E >> 18] + n[128 | E >> 12 & 63] + n[128 | E >> 6 & 63] + n[128 | E & 63];
      }
      N += $.join("");
    }
    return N;
  }, k = function(c) {
    for (var u = [{ obj: { o: c }, prop: "o" }], w = [], m = 0; m < u.length; ++m)
      for (var O = u[m], P = O.obj[O.prop], N = Object.keys(P), I = 0; I < N.length; ++I) {
        var B = N[I], $ = P[B];
        typeof $ == "object" && $ !== null && w.indexOf($) === -1 && (u.push({ obj: P, prop: B }), w.push($));
      }
    return a(u), c;
  }, g = function(c) {
    return Object.prototype.toString.call(c) === "[object RegExp]";
  }, p = function(c) {
    return !c || typeof c != "object" ? !1 : !!(c.constructor && c.constructor.isBuffer && c.constructor.isBuffer(c));
  }, d = function(c, u) {
    return [].concat(c, u);
  }, T = function(c, u) {
    if (t(c)) {
      for (var w = [], m = 0; m < c.length; m += 1)
        w.push(u(c[m]));
      return w;
    }
    return u(c);
  };
  return Kt = {
    arrayToObject: l,
    assign: f,
    combine: d,
    compact: k,
    decode: S,
    encode: b,
    isBuffer: p,
    isRegExp: g,
    maybeMap: T,
    merge: h
  }, Kt;
}
var jt, nn;
function Ka() {
  if (nn) return jt;
  nn = 1;
  var r = Fa(), e = /* @__PURE__ */ Nn(), t = /* @__PURE__ */ tr(), n = Object.prototype.hasOwnProperty, a = {
    brackets: function(s) {
      return s + "[]";
    },
    comma: "comma",
    indices: function(s, c) {
      return s + "[" + c + "]";
    },
    repeat: function(s) {
      return s;
    }
  }, l = Array.isArray, h = Array.prototype.push, f = function(T, s) {
    h.apply(T, l(s) ? s : [s]);
  }, S = Date.prototype.toISOString, v = t.default, b = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: e.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: v,
    formatter: t.formatters[v],
    // deprecated
    indices: !1,
    serializeDate: function(s) {
      return S.call(s);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, k = function(s) {
    return typeof s == "string" || typeof s == "number" || typeof s == "boolean" || typeof s == "symbol" || typeof s == "bigint";
  }, g = {}, p = function T(s, c, u, w, m, O, P, N, I, B, $, G, E, H, W, Z, se, ce) {
    for (var C = s, L = ce, ue = 0, be = !1; (L = L.get(g)) !== void 0 && !be; ) {
      var pe = L.get(s);
      if (ue += 1, typeof pe < "u") {
        if (pe === ue)
          throw new RangeError("Cyclic object value");
        be = !0;
      }
      typeof L.get(g) > "u" && (ue = 0);
    }
    if (typeof B == "function" ? C = B(c, C) : C instanceof Date ? C = E(C) : u === "comma" && l(C) && (C = e.maybeMap(C, function(te) {
      return te instanceof Date ? E(te) : te;
    })), C === null) {
      if (O)
        return I && !Z ? I(c, b.encoder, se, "key", H) : c;
      C = "";
    }
    if (k(C) || e.isBuffer(C)) {
      if (I) {
        var fe = Z ? c : I(c, b.encoder, se, "key", H);
        return [W(fe) + "=" + W(I(C, b.encoder, se, "value", H))];
      }
      return [W(c) + "=" + W(String(C))];
    }
    var ye = [];
    if (typeof C > "u")
      return ye;
    var le;
    if (u === "comma" && l(C))
      Z && I && (C = e.maybeMap(C, I)), le = [{ value: C.length > 0 ? C.join(",") || null : void 0 }];
    else if (l(B))
      le = B;
    else {
      var ee = Object.keys(C);
      le = $ ? ee.sort($) : ee;
    }
    var de = N ? String(c).replace(/\./g, "%2E") : String(c), he = w && l(C) && C.length === 1 ? de + "[]" : de;
    if (m && l(C) && C.length === 0)
      return he + "[]";
    for (var V = 0; V < le.length; ++V) {
      var D = le[V], j = typeof D == "object" && D && typeof D.value < "u" ? D.value : C[D];
      if (!(P && j === null)) {
        var U = G && N ? String(D).replace(/\./g, "%2E") : String(D), M = l(C) ? typeof u == "function" ? u(he, U) : he : he + (G ? "." + U : "[" + U + "]");
        ce.set(s, ue);
        var z = r();
        z.set(g, ce), f(ye, T(
          j,
          M,
          u,
          w,
          m,
          O,
          P,
          N,
          u === "comma" && Z && l(C) ? null : I,
          B,
          $,
          G,
          E,
          H,
          W,
          Z,
          se,
          z
        ));
      }
    }
    return ye;
  }, d = function(s) {
    if (!s)
      return b;
    if (typeof s.allowEmptyArrays < "u" && typeof s.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof s.encodeDotInKeys < "u" && typeof s.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (s.encoder !== null && typeof s.encoder < "u" && typeof s.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var c = s.charset || b.charset;
    if (typeof s.charset < "u" && s.charset !== "utf-8" && s.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var u = t.default;
    if (typeof s.format < "u") {
      if (!n.call(t.formatters, s.format))
        throw new TypeError("Unknown format option provided.");
      u = s.format;
    }
    var w = t.formatters[u], m = b.filter;
    (typeof s.filter == "function" || l(s.filter)) && (m = s.filter);
    var O;
    if (s.arrayFormat in a ? O = s.arrayFormat : "indices" in s ? O = s.indices ? "indices" : "repeat" : O = b.arrayFormat, "commaRoundTrip" in s && typeof s.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var P = typeof s.allowDots > "u" ? s.encodeDotInKeys === !0 ? !0 : b.allowDots : !!s.allowDots;
    return {
      addQueryPrefix: typeof s.addQueryPrefix == "boolean" ? s.addQueryPrefix : b.addQueryPrefix,
      allowDots: P,
      allowEmptyArrays: typeof s.allowEmptyArrays == "boolean" ? !!s.allowEmptyArrays : b.allowEmptyArrays,
      arrayFormat: O,
      charset: c,
      charsetSentinel: typeof s.charsetSentinel == "boolean" ? s.charsetSentinel : b.charsetSentinel,
      commaRoundTrip: !!s.commaRoundTrip,
      delimiter: typeof s.delimiter > "u" ? b.delimiter : s.delimiter,
      encode: typeof s.encode == "boolean" ? s.encode : b.encode,
      encodeDotInKeys: typeof s.encodeDotInKeys == "boolean" ? s.encodeDotInKeys : b.encodeDotInKeys,
      encoder: typeof s.encoder == "function" ? s.encoder : b.encoder,
      encodeValuesOnly: typeof s.encodeValuesOnly == "boolean" ? s.encodeValuesOnly : b.encodeValuesOnly,
      filter: m,
      format: u,
      formatter: w,
      serializeDate: typeof s.serializeDate == "function" ? s.serializeDate : b.serializeDate,
      skipNulls: typeof s.skipNulls == "boolean" ? s.skipNulls : b.skipNulls,
      sort: typeof s.sort == "function" ? s.sort : null,
      strictNullHandling: typeof s.strictNullHandling == "boolean" ? s.strictNullHandling : b.strictNullHandling
    };
  };
  return jt = function(T, s) {
    var c = T, u = d(s), w, m;
    typeof u.filter == "function" ? (m = u.filter, c = m("", c)) : l(u.filter) && (m = u.filter, w = m);
    var O = [];
    if (typeof c != "object" || c === null)
      return "";
    var P = a[u.arrayFormat], N = P === "comma" && u.commaRoundTrip;
    w || (w = Object.keys(c)), u.sort && w.sort(u.sort);
    for (var I = r(), B = 0; B < w.length; ++B) {
      var $ = w[B], G = c[$];
      u.skipNulls && G === null || f(O, p(
        G,
        $,
        P,
        N,
        u.allowEmptyArrays,
        u.strictNullHandling,
        u.skipNulls,
        u.encodeDotInKeys,
        u.encode ? u.encoder : null,
        u.filter,
        u.sort,
        u.allowDots,
        u.serializeDate,
        u.format,
        u.formatter,
        u.encodeValuesOnly,
        u.charset,
        I
      ));
    }
    var E = O.join(u.delimiter), H = u.addQueryPrefix === !0 ? "?" : "";
    return u.charsetSentinel && (u.charset === "iso-8859-1" ? H += "utf8=%26%2310003%3B&" : H += "utf8=%E2%9C%93&"), E.length > 0 ? H + E : "";
  }, jt;
}
var Wt, an;
function ja() {
  if (an) return Wt;
  an = 1;
  var r = /* @__PURE__ */ Nn(), e = Object.prototype.hasOwnProperty, t = Array.isArray, n = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: r.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, a = function(g) {
    return g.replace(/&#(\d+);/g, function(p, d) {
      return String.fromCharCode(parseInt(d, 10));
    });
  }, l = function(g, p, d) {
    if (g && typeof g == "string" && p.comma && g.indexOf(",") > -1)
      return g.split(",");
    if (p.throwOnLimitExceeded && d >= p.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + p.arrayLimit + " element" + (p.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return g;
  }, h = "utf8=%26%2310003%3B", f = "utf8=%E2%9C%93", S = function(p, d) {
    var T = { __proto__: null }, s = d.ignoreQueryPrefix ? p.replace(/^\?/, "") : p;
    s = s.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var c = d.parameterLimit === 1 / 0 ? void 0 : d.parameterLimit, u = s.split(
      d.delimiter,
      d.throwOnLimitExceeded ? c + 1 : c
    );
    if (d.throwOnLimitExceeded && u.length > c)
      throw new RangeError("Parameter limit exceeded. Only " + c + " parameter" + (c === 1 ? "" : "s") + " allowed.");
    var w = -1, m, O = d.charset;
    if (d.charsetSentinel)
      for (m = 0; m < u.length; ++m)
        u[m].indexOf("utf8=") === 0 && (u[m] === f ? O = "utf-8" : u[m] === h && (O = "iso-8859-1"), w = m, m = u.length);
    for (m = 0; m < u.length; ++m)
      if (m !== w) {
        var P = u[m], N = P.indexOf("]="), I = N === -1 ? P.indexOf("=") : N + 1, B, $;
        I === -1 ? (B = d.decoder(P, n.decoder, O, "key"), $ = d.strictNullHandling ? null : "") : (B = d.decoder(P.slice(0, I), n.decoder, O, "key"), $ = r.maybeMap(
          l(
            P.slice(I + 1),
            d,
            t(T[B]) ? T[B].length : 0
          ),
          function(E) {
            return d.decoder(E, n.decoder, O, "value");
          }
        )), $ && d.interpretNumericEntities && O === "iso-8859-1" && ($ = a(String($))), P.indexOf("[]=") > -1 && ($ = t($) ? [$] : $);
        var G = e.call(T, B);
        G && d.duplicates === "combine" ? T[B] = r.combine(T[B], $) : (!G || d.duplicates === "last") && (T[B] = $);
      }
    return T;
  }, v = function(g, p, d, T) {
    var s = 0;
    if (g.length > 0 && g[g.length - 1] === "[]") {
      var c = g.slice(0, -1).join("");
      s = Array.isArray(p) && p[c] ? p[c].length : 0;
    }
    for (var u = T ? p : l(p, d, s), w = g.length - 1; w >= 0; --w) {
      var m, O = g[w];
      if (O === "[]" && d.parseArrays)
        m = d.allowEmptyArrays && (u === "" || d.strictNullHandling && u === null) ? [] : r.combine([], u);
      else {
        m = d.plainObjects ? { __proto__: null } : {};
        var P = O.charAt(0) === "[" && O.charAt(O.length - 1) === "]" ? O.slice(1, -1) : O, N = d.decodeDotInKeys ? P.replace(/%2E/g, ".") : P, I = parseInt(N, 10);
        !d.parseArrays && N === "" ? m = { 0: u } : !isNaN(I) && O !== N && String(I) === N && I >= 0 && d.parseArrays && I <= d.arrayLimit ? (m = [], m[I] = u) : N !== "__proto__" && (m[N] = u);
      }
      u = m;
    }
    return u;
  }, b = function(p, d, T, s) {
    if (p) {
      var c = T.allowDots ? p.replace(/\.([^.[]+)/g, "[$1]") : p, u = /(\[[^[\]]*])/, w = /(\[[^[\]]*])/g, m = T.depth > 0 && u.exec(c), O = m ? c.slice(0, m.index) : c, P = [];
      if (O) {
        if (!T.plainObjects && e.call(Object.prototype, O) && !T.allowPrototypes)
          return;
        P.push(O);
      }
      for (var N = 0; T.depth > 0 && (m = w.exec(c)) !== null && N < T.depth; ) {
        if (N += 1, !T.plainObjects && e.call(Object.prototype, m[1].slice(1, -1)) && !T.allowPrototypes)
          return;
        P.push(m[1]);
      }
      if (m) {
        if (T.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + T.depth + " and strictDepth is true");
        P.push("[" + c.slice(m.index) + "]");
      }
      return v(P, d, T, s);
    }
  }, k = function(p) {
    if (!p)
      return n;
    if (typeof p.allowEmptyArrays < "u" && typeof p.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof p.decodeDotInKeys < "u" && typeof p.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (p.decoder !== null && typeof p.decoder < "u" && typeof p.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof p.charset < "u" && p.charset !== "utf-8" && p.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof p.throwOnLimitExceeded < "u" && typeof p.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var d = typeof p.charset > "u" ? n.charset : p.charset, T = typeof p.duplicates > "u" ? n.duplicates : p.duplicates;
    if (T !== "combine" && T !== "first" && T !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var s = typeof p.allowDots > "u" ? p.decodeDotInKeys === !0 ? !0 : n.allowDots : !!p.allowDots;
    return {
      allowDots: s,
      allowEmptyArrays: typeof p.allowEmptyArrays == "boolean" ? !!p.allowEmptyArrays : n.allowEmptyArrays,
      allowPrototypes: typeof p.allowPrototypes == "boolean" ? p.allowPrototypes : n.allowPrototypes,
      allowSparse: typeof p.allowSparse == "boolean" ? p.allowSparse : n.allowSparse,
      arrayLimit: typeof p.arrayLimit == "number" ? p.arrayLimit : n.arrayLimit,
      charset: d,
      charsetSentinel: typeof p.charsetSentinel == "boolean" ? p.charsetSentinel : n.charsetSentinel,
      comma: typeof p.comma == "boolean" ? p.comma : n.comma,
      decodeDotInKeys: typeof p.decodeDotInKeys == "boolean" ? p.decodeDotInKeys : n.decodeDotInKeys,
      decoder: typeof p.decoder == "function" ? p.decoder : n.decoder,
      delimiter: typeof p.delimiter == "string" || r.isRegExp(p.delimiter) ? p.delimiter : n.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof p.depth == "number" || p.depth === !1 ? +p.depth : n.depth,
      duplicates: T,
      ignoreQueryPrefix: p.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof p.interpretNumericEntities == "boolean" ? p.interpretNumericEntities : n.interpretNumericEntities,
      parameterLimit: typeof p.parameterLimit == "number" ? p.parameterLimit : n.parameterLimit,
      parseArrays: p.parseArrays !== !1,
      plainObjects: typeof p.plainObjects == "boolean" ? p.plainObjects : n.plainObjects,
      strictDepth: typeof p.strictDepth == "boolean" ? !!p.strictDepth : n.strictDepth,
      strictNullHandling: typeof p.strictNullHandling == "boolean" ? p.strictNullHandling : n.strictNullHandling,
      throwOnLimitExceeded: typeof p.throwOnLimitExceeded == "boolean" ? p.throwOnLimitExceeded : !1
    };
  };
  return Wt = function(g, p) {
    var d = k(p);
    if (g === "" || g === null || typeof g > "u")
      return d.plainObjects ? { __proto__: null } : {};
    for (var T = typeof g == "string" ? S(g, d) : g, s = d.plainObjects ? { __proto__: null } : {}, c = Object.keys(T), u = 0; u < c.length; ++u) {
      var w = c[u], m = b(w, T[w], d, typeof g == "string");
      s = r.merge(s, m, d);
    }
    return d.allowSparse === !0 ? s : r.compact(s);
  }, Wt;
}
var Mt, on;
function Wa() {
  if (on) return Mt;
  on = 1;
  var r = /* @__PURE__ */ Ka(), e = /* @__PURE__ */ ja(), t = /* @__PURE__ */ tr();
  return Mt = {
    formats: t,
    parse: e,
    stringify: r
  }, Mt;
}
var Ma = /* @__PURE__ */ Wa();
class Va {
  constructor() {
    this.ENDPOINTS = {
      all: (e = "") => _({
        regular: `api/v3/reservations/?${e}`,
        sdk: `sdk/api/v1/reservations/?${e}`
      }),
      getOne: (e = "") => _({
        regular: `api/v4/reservations/${e}/`,
        sdk: `sdk/api/v2/reservations/${e}/?is_housing_deactivated=true`
      }),
      getOneV3: (e = "") => _({
        regular: `api/v3/reservations/${e}/`,
        sdk: `sdk/api/v1/reservations/${e}/`
      }),
      getByExternalId: (e = "") => _({
        regular: `api/v4/reservations/get-with-external-id/?external_id=${encodeURIComponent(
          e
        )}`,
        sdk: `sdk/api/v2/reservations/get-with-external-id/?external_id=${encodeURIComponent(
          e
        )}&is_housing_deactivated=true`
      }),
      getSummary: (e = "") => _({
        regular: `api/v4/guestapp/reservations/${e}/summary/`,
        sdk: `sdk/api/v1/guestapp/reservations/${e}/summary/`
      }),
      directReservation: "api/v4/reservations/direct-reservation"
    };
  }
  async getOne({ id: e, externalId: t }, n) {
    const a = t ? this.ENDPOINTS.getByExternalId(t) : this.ENDPOINTS.getOne(e);
    return (await y.get(a, {
      requireEncryption: !0,
      ...n
    })).body;
  }
  async getSummary(e, t) {
    return (await y.get(
      this.ENDPOINTS.getSummary(e),
      t
    )).body;
  }
  async findReservation(e, t) {
    return (await y.get(
      this.ENDPOINTS.all(Ma.stringify(e)),
      t
    )).body;
  }
  async getOrCreateDirectReservation(e, t) {
    return (await y.post(
      this.ENDPOINTS.directReservation,
      {
        json: e,
        ...t
      }
    )).body;
  }
  async createReservation(e, t) {
    return (await y.post(this.ENDPOINTS.all(), {
      json: e,
      ...t
    })).body;
  }
  async updateReservation(e, t, n) {
    return (await y.patch(
      this.ENDPOINTS.getOneV3(e),
      {
        json: t,
        ...n
      }
    )).body;
  }
}
class Ha {
  constructor() {
    this.ENDPOINTS = {
      search: (e = "") => `api/v4/locations-search/?${e}`,
      getByHousingId: (e = "") => `api/v4/locations/${e}/`,
      spanishResidenceCities: (e = "") => `api/v3/es-municipalities-names/?${e}`
    };
  }
  async fetchAllCountries(e) {
    return (await y.get(
      this.ENDPOINTS.search("phone_code=1&no_pagination=true"),
      e
    )).body;
  }
  async getByHousingId(e = "", t) {
    return (await y.get(
      this.ENDPOINTS.getByHousingId(e),
      t
    )).body;
  }
  async fetchPaginatedLocationsList(e = "") {
    return (await y.get(this.ENDPOINTS.search(e))).body;
  }
  fetchCountriesList({ page: e, searchQuery: t = "" }) {
    return this.fetchPaginatedLocationsList(
      `phone_code=1&page=${e}&q=${encodeURIComponent(t)}`
    );
  }
  fetchProvincesList({
    page: e,
    searchQuery: t = "",
    countryCode: n
  }) {
    return this.fetchPaginatedLocationsList(
      `country=${n}&page=${e}&q=${encodeURIComponent(t)}`
    );
  }
  fetchCitiesList({ page: e, searchQuery: t = "", countryCode: n }) {
    return this.fetchPaginatedLocationsList(
      `country=${n}&division_level=3&page=${e}&q=${encodeURIComponent(
        t
      )}`
    );
  }
  fetchDistrictsList({
    page: e,
    searchQuery: t = "",
    countryCode: n
  }) {
    return this.fetchPaginatedLocationsList(
      `country=${n}&division_level=1&page=${e}&q=${encodeURIComponent(
        t
      )}`
    );
  }
  fetchMunicipalitiesList({
    page: e,
    searchQuery: t = "",
    countryCode: n,
    district: a
  }) {
    return this.fetchPaginatedLocationsList(
      `country=${n}&division_level=2&department=${a}&page=${e}&q=${encodeURIComponent(
        t
      )}`
    );
  }
  fetchPhoneCodesList({ page: e, searchQuery: t = "" }) {
    return this.fetchPaginatedLocationsList(
      `phone_code=1&page=${e}&q=${encodeURIComponent(t)}`
    );
  }
  async fetchSpanishResidenceCitiesList({ page: e = 1, searchQuery: t = "" }, n) {
    return (await y.get(
      this.ENDPOINTS.spanishResidenceCities(
        `page=${e}&q=${encodeURIComponent(t)}`
      ),
      n
    )).body;
  }
  async fetchLocationsByExternalUrl({ url: e, page: t = 1, searchQuery: n = "" }, a) {
    const l = new URL(e);
    return l.searchParams.set("page", t.toString()), l.searchParams.set("q", encodeURIComponent(n)), (await y.get("", {
      ...a,
      externalURL: l.href
    })).body;
  }
}
class za {
  constructor() {
    this.ENDPOINTS = {
      biomatchIdentification: (e = "") => `api/v4/biomatch/identification/${e ? `${e}/` : ""}`,
      biomatchPerson: (e = "") => `api/v4/biomatch/person/${e ? `${e}/` : ""}`,
      biomatchCompare: (e = "") => `api/v4/biomatch/compare/${e ? `${e}/` : ""}`,
      ocrPicture: () => "api/v3/ocr/picture/",
      ocrData: (e = "") => `api/v3/ocr/data/${e ? `${e}/` : ""}`,
      ivIntent: (e = "") => `api/v3/ocr/iv-intent/${e ? `${e}/` : ""}`,
      startIVOnMobile: () => "api/v3/ocr/process-iv-by-qr/start-iv-on-mobile",
      finishIVByQr: () => "api/v3/ocr/process-iv-by-qr/finish-iv-by-qr",
      schemaIVSDK: () => _({
        regular: "api/v4/guestapp/guests/schema-iv-sdk/",
        sdk: "sdk/api/v1/guestapp/guests/schema-iv-sdk/"
      })
    }, this.sendDocumentForFaceDetection = async (e, t) => (await y.post(
      this.ENDPOINTS.biomatchIdentification(),
      {
        json: e,
        ...t
      }
    )).body, this.checkDocumentFaceDetectionStatus = async (e, t) => (await y.get(
      this.ENDPOINTS.biomatchIdentification(e),
      t
    )).body, this.sendSelfieForFaceDetection = async (e, t) => (await y.post(
      this.ENDPOINTS.biomatchPerson(),
      {
        json: e,
        ...t
      }
    )).body, this.checkSelfieFaceDetection = async (e, t) => (await y.get(
      this.ENDPOINTS.biomatchPerson(e),
      t
    )).body, this.compareSelfieAndDocumentFaces = async (e, t) => (await y.post(
      this.ENDPOINTS.biomatchCompare(),
      {
        json: e,
        ...t
      }
    )).body, this.checkSelfieAndDocumentFacesComparingStatus = async (e = "", t) => (await y.get(
      this.ENDPOINTS.biomatchCompare(e),
      t
    )).body, this.sendImageForOCR = async (e, t) => (await y.post(this.ENDPOINTS.ocrPicture(), {
      json: e,
      ...t
    })).body, this.checkImageOCRStatus = async (e = "", t) => (await y.get(
      this.ENDPOINTS.ocrData(e),
      t
    )).body, this.createIvIntent = async (e, t) => (await y.post(
      this.ENDPOINTS.ivIntent(),
      {
        json: e,
        ...t
      }
    )).body, this.updateIvIntent = async (e, t) => (await y.patch(
      this.ENDPOINTS.ivIntent(e.id),
      {
        json: e,
        ...t
      }
    )).body, this.getIvIntent = async (e, t) => (await y.get(
      this.ENDPOINTS.ivIntent(e),
      t
    )).body, this.startIVOnMobile = async (e, t) => (await y.post(this.ENDPOINTS.startIVOnMobile(), {
      json: {
        iv_intent_id: e
      },
      ...t
    })).body, this.finishIVByQr = async (e, t) => (await y.post(this.ENDPOINTS.finishIVByQr(), {
      json: e,
      ...t
    })).body, this.getIVSDKSchema = async (e, t) => (await y.post(
      this.ENDPOINTS.schemaIVSDK(),
      {
        json: e,
        ...t
      }
    )).body;
  }
}
class Ja {
  constructor() {
    this.ENDPOINTS = {
      allExemptions: (e = "") => `api/v3/stat-tax-exemptions/?${e}`,
      season: (e) => _({
        regular: `api/v3/seasons/${e}/`,
        sdk: `sdk/api/v1/seasons/${e}/`
      }),
      seasonGuests: (e = "") => _({
        regular: `api/v3/season-guests/?${e}`,
        sdk: `sdk/api/v1/season-guests/?${e}`
      }),
      guestTaxes: (e = "", t = "") => _({
        regular: `api/v3/season-guests/${e}/?${t}`,
        sdk: `sdk/api/v1/season-guests/${e}/?${t}`
      }),
      initGuestTaxes: () => _({
        regular: "api/v3/season-guests/init/",
        sdk: "sdk/api/v1/season-guests/init/"
      })
    };
  }
  async getAllExemptions(e = "", t) {
    return (await y.get(
      this.ENDPOINTS.allExemptions(e),
      t
    )).body;
  }
  async getSeason(e, t) {
    return (await y.get(
      this.ENDPOINTS.season(e),
      t
    )).body;
  }
  async getSeasonGuests(e = "", t) {
    return (await y.get(
      this.ENDPOINTS.seasonGuests(e),
      t
    )).body;
  }
  async initGuestTaxes(e, t) {
    return (await y.post(this.ENDPOINTS.initGuestTaxes(), {
      json: e,
      ...t
    })).body;
  }
  async calculateGuestTax({ id: e, ...t }, n, a) {
    return e ? (await y.patch(
      this.ENDPOINTS.guestTaxes(e, n),
      {
        json: t,
        ...a
      }
    )).body : (await y.post(
      this.ENDPOINTS.seasonGuests(n),
      {
        json: t,
        ...a
      }
    )).body;
  }
}
class Qa {
  constructor() {
    this.ENDPOINTS = {
      getPurposeOfStay: (e = "") => _({
        regular: `api/v3/purposes-of-stay/?${e}`,
        sdk: `sdk/api/v1/purposes-of-stay/?${e}`
      })
    };
  }
  async getPurposeOfStay(e) {
    return (await y.get(
      this.ENDPOINTS.getPurposeOfStay(),
      e
    )).body;
  }
}
class Xa {
  constructor() {
    this.ENDPOINTS = {
      getOne: (e = "") => _({
        regular: `api/v4/housings/${e}/`,
        sdk: `sdk/api/v2/housings/${e}/`
      }),
      checkoutSetting: (e = "") => `api/v3/housing-check-out-settings/${e}`
    };
  }
  async getOne(e, t) {
    return (await y.get(
      this.ENDPOINTS.getOne(e),
      t
    )).body;
  }
  async getCheckoutSetting(e, t) {
    return (await y.get(
      this.ENDPOINTS.checkoutSetting(e),
      t
    )).body;
  }
  // TODO check the access
  async getLocation(e) {
    return (await y.get("", e)).body;
  }
}
class Za {
  constructor() {
    this.ENDPOINTS = {
      contracts: (e = "") => `api/v3/documents/contracts/?${e}`,
      documentsPrivacyPolicy: (e) => `api/v3/documents/privacy-policy-settings/${e}/`
    };
  }
  async getContracts(e = "", t) {
    return (await y.get(
      this.ENDPOINTS.contracts(e),
      t
    )).body;
  }
  async getPrivacyPolicy(e, t) {
    return (await y.get(
      this.ENDPOINTS.documentsPrivacyPolicy(e),
      t
    )).body;
  }
}
class La {
  constructor() {
    this.ENDPOINTS = {
      guestGroup: (e = "") => _({
        regular: `api/v4/guestapp/guest-group/${e}/`,
        sdk: `sdk/api/v1/guestapp/guest-group/${e}/`
      })
    };
  }
  async getGuestGroup(e, t) {
    return (await y.get(this.ENDPOINTS.guestGroup(e), {
      requireEncryption: !0,
      ...t
    })).body;
  }
  async patchGuestGroup(e, t, n) {
    return (await y.patch(this.ENDPOINTS.guestGroup(e), {
      json: t,
      ...n
    })).body;
  }
}
class Ya {
  constructor() {
    this.ENDPOINTS = {
      paymentsSettings: (e = "") => _({
        regular: `api/v3/payments-settings/?${e}`,
        sdk: `sdk/api/v1/payments-settings/?${e}`
      }),
      checkExpiredReservationPayments: () => _({
        regular: "api/v3/reservation-payments/check-expired/",
        sdk: "sdk/api/v1/reservation-payments/check-expired/"
      }),
      multiPayments: () => _({
        regular: "api/v4/multi-payments/",
        sdk: "sdk/api/v2/multi-payments/"
      }),
      oneMultiPayment: (e) => _({
        regular: `api/v4/multi-payments/${e}/`,
        sdk: `sdk/api/v2/multi-payments/${e}/`
      }),
      addon: (e) => _({
        regular: `api/v4/multi-payments/${e}/addon/`,
        sdk: `sdk/api/v2/multi-payments/${e}/addon/`
      }),
      paymentsCart: (e = "") => _({
        regular: `api/v4/payments-cart/?${e}`,
        sdk: `sdk/api/v2/payments-cart/?${e}`
      }),
      orderHistory: (e = "") => _({
        regular: `api/v4/order-history/?${e}`,
        sdk: `sdk/api/v2/order-history/?${e}`
      }),
      reservationPayments: (e = "") => `api/v3/reservation-payments/?reservation=${e}`
    }, this.checkExpiredReservationPayments = async (e, t) => (await y.post(
      this.ENDPOINTS.checkExpiredReservationPayments(),
      { json: e, ...t }
    )).body, this.getMultiPayment = async (e, t) => (await y.get(
      this.ENDPOINTS.oneMultiPayment(e),
      t
    )).body;
  }
  async getPaymentsSettings(e = "", t) {
    return (await y.get(
      this.ENDPOINTS.paymentsSettings(e),
      t
    )).body;
  }
  async createMultiPayment(e, t) {
    return (await y.post(this.ENDPOINTS.multiPayments(), {
      json: e,
      ...t
    })).body;
  }
  async getPaymentsCart(e, t) {
    return (await y.get(
      this.ENDPOINTS.paymentsCart(e),
      t
    )).body;
  }
  async getOrderHistory(e, t) {
    return (await y.get(
      this.ENDPOINTS.orderHistory(e),
      t
    )).body;
  }
  async getReservationPayments(e, t) {
    return (await y.get(
      this.ENDPOINTS.reservationPayments(e),
      t
    )).body;
  }
  async getAddonMultiPayment(e, t) {
    return (await y.get(
      this.ENDPOINTS.addon(e),
      t
    )).body;
  }
}
const ei = "https://www.guruwalk.com";
class ti {
  constructor() {
    this.ENDPOINTS = {
      offers: (e = "") => _({
        regular: `api/v3/upselling/offers/?${e}`,
        sdk: `sdk/api/v1/upselling/offers/?${e}`
      }),
      deals: (e = "") => _({
        regular: `api/v3/upselling/deals/?${e}`,
        sdk: `sdk/api/v1/upselling/deals/?${e}`
      }),
      createBulkDeal: () => _({
        regular: "api/v3/upselling/deals/bulk-create/",
        sdk: "sdk/api/v1/upselling/deals/bulk-create/"
      }),
      oneDeal: (e) => _({
        regular: `api/v3/upselling/deals/${e}/`,
        sdk: `sdk/api/v1/upselling/deals/${e}/`
      }),
      oneOffer: (e) => _({
        regular: `api/v3/upselling/offers/${e}/`,
        sdk: `sdk/api/v1/upselling/offers/${e}/`
      }),
      oneOfferBySlug: (e) => _({
        regular: `api/v3/upselling/offers/slug/${e}/`,
        sdk: `sdk/api/v1/upselling/offers/slug/${e}/`
      }),
      thirdPartyDeal: (e) => _({
        regular: `api/v3/upselling/third-party-deals/${e}`,
        sdk: `sdk/api/v1/upselling/third-party-deals/${e}`
      }),
      bulkLock: (e) => _({
        regular: `api/v3/upselling/third-party-deals/bulk-lock/${e}`,
        sdk: `sdk/api/v1/upselling/third-party-deals/bulk-lock/${e}`
      }),
      exists: (e = "") => _({
        regular: `api/v3/upselling/offers/exists/?${e}`,
        sdk: `sdk/api/v1/upselling/offers/exists/?${e}`
      }),
      topOffers: (e) => _({
        regular: `api/v3/upselling/offers/reservations/${e}/top-offers/`,
        sdk: `sdk/api/v1/upselling/offers/reservations/${e}/top-offers/`
      }),
      esimPackages: (e = "") => _({
        regular: `api/v3/upselling/airalo/packages/?${e}`,
        sdk: `sdk/api/v1/upselling/airalo/packages/?${e}`
      }),
      createEsimOrder: () => _({
        regular: "api/v3/upselling/airalo/orders/",
        sdk: "sdk/api/v1/upselling/airalo/orders/"
      }),
      esims: (e = "") => _({
        regular: `api/v3/upselling/airalo/sims/?${e}`,
        sdk: `sdk/api/v1/upselling/airalo/sims/?${e}`
      }),
      esimInstructions: (e) => _({
        regular: `api/v3/upselling/airalo/sims/${e}`,
        sdk: `sdk/api/v1/upselling/airalo/sims/${e}`
      }),
      upsellingAiraloFeature: () => _({
        regular: "api/v3/upselling/airalo/feature/",
        sdk: "sdk/api/v1/upselling/airalo/feature/"
      }),
      getCompatibleDevices: (e = "") => _({
        regular: `api/v3/upselling/airalo/devices/?${e}`,
        sdk: `sdk/api/v1/upselling/airalo/devices/?${e}`
      })
    };
  }
  async getCompatibleDevices(e = "", t) {
    return (await y.get(
      this.ENDPOINTS.getCompatibleDevices(e),
      t
    )).body;
  }
  async getUpsellingEsimFeature(e) {
    return (await y.get(
      this.ENDPOINTS.upsellingAiraloFeature(),
      e
    )).body;
  }
  async getEsimPackages(e, t = "", n) {
    return (await y.post(
      this.ENDPOINTS.esimPackages(t),
      { json: e, ...n }
    )).body;
  }
  async getEsims(e = "", t) {
    return (await y.get(
      this.ENDPOINTS.esims(e),
      t
    )).body;
  }
  async getEsimInstructions(e, t) {
    return (await y.get(
      this.ENDPOINTS.esimInstructions(e),
      t
    )).body;
  }
  async createEsimOrder(e, t) {
    return (await y.post(this.ENDPOINTS.createEsimOrder(), {
      json: e,
      ...t
    })).body;
  }
  async getOffers(e = "", t) {
    return (await y.get(
      this.ENDPOINTS.offers(e),
      t
    )).body;
  }
  async getOffer(e, t) {
    return (await y.get(
      this.ENDPOINTS.oneOffer(e),
      t
    )).body;
  }
  async getOfferBySlug(e, t) {
    return (await y.get(
      this.ENDPOINTS.oneOfferBySlug(e),
      t
    )).body;
  }
  async getTopOffers(e, t) {
    return (await y.get(
      this.ENDPOINTS.topOffers(e),
      t
    )).body;
  }
  async getDeals(e = "", t) {
    return (await y.get(
      this.ENDPOINTS.deals(e),
      t
    )).body;
  }
  async deleteDeal(e, t) {
    return (await y.delete(
      this.ENDPOINTS.oneDeal(e),
      t
    )).body;
  }
  async createBulkDeal(e, t) {
    return (await y.post(this.ENDPOINTS.createBulkDeal(), {
      json: e,
      ...t
    })).body;
  }
  async createOrUpdateThirdPartyDeal(e, t) {
    const n = e?.deal_id ? "patch" : "post";
    return (await y[n](
      this.ENDPOINTS.thirdPartyDeal(e?.deal_id ?? ""),
      { json: e, ...t }
    )).body;
  }
  async createOrUpdateBuildLock(e, t) {
    const n = e?.bulk_lock_id ? "patch" : "post";
    return (await y[n](
      this.ENDPOINTS.bulkLock(e?.bulk_lock_id ?? ""),
      { json: e, ...t }
    )).body;
  }
  async fetchCheckIfOffersExists(e = "", t) {
    return (await y.get(
      this.ENDPOINTS.exists(e),
      t
    )).body;
  }
  async getGuruWalkTours({
    locality: e,
    language: t,
    limit: n,
    country: a,
    checkIn: l,
    checkOut: h
  }) {
    const f = new URL("/api/v2/tours", ei);
    f.searchParams.set("locality", e), f.searchParams.set("lang", t), f.searchParams.set("country", a), f.searchParams.set("from", l), f.searchParams.set("to", h), f.searchParams.set("api_key", "1wCMGgErWUxqVGDNjPX1cw"), n && f.searchParams.set("limit", String(n));
    const v = await fetch(f.toString());
    if (!v.ok)
      throw new Error("Failed to fetch GuruWalk tours");
    const b = await v.json();
    return (Array.isArray(b?.objects) ? b.objects : []).map(
      (g) => ({
        id: String(g.id),
        title: g.title,
        description: g.description.replace(/<[^>]*>/g, ""),
        url: g.url,
        imageUrl: g.image?.original,
        ratingAverage: g.ratingAverage ? parseFloat(g.ratingAverage) : void 0,
        testimonialsCount: g.testimonialsCount
      })
    );
  }
}
class ri {
  constructor() {
    this.ENDPOINTS = {
      getPropertyProtectionsByReservation: (e) => _({
        regular: `api/v3/insurance/property-protection-for-reservation/${e}/`,
        sdk: `sdk/api/v1/insurance/property-protection-for-reservation/${e}/`
      }),
      insuranceSetup: (e = "") => _({
        regular: `api/v4/insurance-setup/${e ? e + "/" : ""}`,
        sdk: `sdk/api/v2/insurance-setup/${e ? e + "/" : ""}`
      })
    };
  }
  async getPropertyProtectionsByReservation(e, t) {
    return (await y.get(
      this.ENDPOINTS.getPropertyProtectionsByReservation(e),
      t
    )).body;
  }
  async mutateInsuranceSetup({ id: e, ...t }, n) {
    return (await y[e ? "patch" : "post"](
      this.ENDPOINTS.insuranceSetup(e),
      { json: t, ...n }
    )).body;
  }
  async getInsuranceSetup(e, t) {
    return (await y.get(
      this.ENDPOINTS.insuranceSetup(e),
      t
    )).body;
  }
}
class ni {
  constructor() {
    this.ENDPOINTS = {
      unlock: (e = "") => _({
        regular: `api/v3/locks/unlock/?${e}`,
        sdk: `sdk/api/v1/locks/unlock/?${e}`
      }),
      getLocks: (e = "") => _({
        regular: `api/v4/guestapp/locks/?${e}`,
        sdk: `sdk/api/v1/guestapp/locks/?${e}`
      }),
      getLockConditions: (e = "") => _({
        regular: `api/v4/guestapp/reservation-conditions/?${e}`,
        sdk: `sdk/api/v1/guestapp/reservation-conditions/?${e}`
      }),
      locksRooms: (e) => `api/v3/locks/${e}/get-external-locks/`
    };
  }
  async getLocks(e = "", t) {
    return (await y.get(
      this.ENDPOINTS.getLocks(e),
      { requireEncryption: !0, ...t }
    )).body.results?.[0]?.unlock_links ?? [];
  }
  async getLockConditions(e = "", t) {
    return (await y.get(
      this.ENDPOINTS.getLockConditions(e),
      t
    )).body;
  }
  async unlock(e = "", t) {
    return (await y.get(
      this.ENDPOINTS.unlock(e),
      t
    )).body;
  }
  async getLocksRooms(e, t) {
    return (await y.get(
      this.ENDPOINTS.locksRooms(e),
      t
    )).body;
  }
}
class ai {
  constructor() {
    this.ENDPOINTS = {
      getCustomTheme: (e = "") => _({
        regular: `api/v4/branding/templates/${e}/`,
        sdk: `sdk/api/v1/branding/templates/${e}/`
      })
    };
  }
  async getCustomTheme(e, t) {
    return (await y.get(
      this.ENDPOINTS.getCustomTheme(e),
      t
    )).body;
  }
}
class ii {
  constructor() {
    this.ENDPOINTS = {
      all: (e) => `api/v3/documents-v2/guidebooks/reservations/${e}/`,
      guidebook: (e, t) => `api/v3/documents-v2/guidebooks/${e}/reservations/${t}/`,
      group: (e) => `api/v3/documents-v2/guidebook-groups/${e}/guidebooks/`,
      byHousing: (e) => `api/v3/documents-v2/guidebook-groups/housings/${e}/?is_active=true`
    };
  }
  async getGuidebooks(e, t) {
    return (await y.get(
      this.ENDPOINTS.all(e),
      t
    )).body;
  }
  async getGuidebook(e, t, n) {
    return (await y.get(
      this.ENDPOINTS.guidebook(e, t),
      n
    )).body;
  }
  async getGuidebooksByHousing(e, t) {
    return (await y.get(
      this.ENDPOINTS.byHousing(e),
      t
    )).body;
  }
  async getGuidebooksByGroup(e, t) {
    return (await y.get(
      this.ENDPOINTS.group(e),
      t
    )).body;
  }
}
class oi {
  constructor() {
    this.ENDPOINTS = {
      createFeedback: () => "api/v3/feedbacks/",
      checkoutFeedback: () => "api/v3/reservation-check-out-feedbacks/"
    };
  }
  async createFeedback(e, t) {
    return (await y.post(this.ENDPOINTS.createFeedback(), {
      json: e,
      ...t
    })).body;
  }
  async createCheckoutFeedback(e, t) {
    return (await y.post(
      this.ENDPOINTS.checkoutFeedback(),
      {
        json: e,
        ...t
      }
    )).body;
  }
}
const Ui = {
  email: "email",
  phone: "phone_number"
};
class si {
  constructor() {
    this.ENDPOINTS = {
      generate: () => "api/v1/verification/generate/",
      verify: () => "api/v1/verification/verify/",
      settings: (e) => `api/v1/verification/settings?housing=${e}`
    };
  }
  async generate(e, t) {
    return (await y.post(this.ENDPOINTS.generate(), {
      json: e,
      ...t
    })).body;
  }
  async verify(e, t) {
    return (await y.post(this.ENDPOINTS.verify(), {
      json: e,
      ...t
    })).body;
  }
  async getSettings(e, t) {
    return (await y.get(
      this.ENDPOINTS.settings(e),
      t
    )).body;
  }
}
class ci {
  constructor() {
    this.ENDPOINTS = {
      printedCards: (e = "") => `api/v4/guestapp/reservations/${e}/printed-cards/`
    };
  }
  async getPrintedCards(e, t) {
    return (await y.get(
      this.ENDPOINTS.printedCards(e),
      t
    )).body;
  }
  async addPrintedCard(e, t) {
    return (await y.post(
      this.ENDPOINTS.printedCards(e),
      t
    )).body;
  }
}
class ui {
  constructor() {
    this.locationApi = new Ha();
  }
  getAllCountries(e) {
    return this.locationApi.fetchAllCountries(e);
  }
  getHousingLocation(e, t) {
    return this.locationApi.getByHousingId(e, t);
  }
  transformPaginatedListToOptions(e, t) {
    return e.then((n) => ({
      ...n,
      results: t(n)
    }));
  }
  getCountriesList({
    phoneCodesOptions: e,
    ...t
  }) {
    const n = this.locationApi.fetchCountriesList(t);
    return this.transformPaginatedListToOptions(
      n,
      e ? Q.getPhoneCodesAsOptions : Q.getCountriesAsOptions
    );
  }
  getProvincesList(e) {
    const t = this.locationApi.fetchProvincesList(e);
    return this.transformPaginatedListToOptions(
      t,
      Q.getProvincesAsOptions
    );
  }
  getCitiesList(e) {
    const t = this.locationApi.fetchCitiesList(e);
    return this.transformPaginatedListToOptions(
      t,
      Q.getCitiesAsOptions
    );
  }
  getDistrictsList(e) {
    const t = this.locationApi.fetchDistrictsList(e);
    return this.transformPaginatedListToOptions(
      t,
      Q.getDistrictsAsOptions
    );
  }
  getMunicipalitiesList(e) {
    const t = this.locationApi.fetchMunicipalitiesList(e);
    return this.transformPaginatedListToOptions(
      t,
      Q.getProvincesAsOptions
    );
  }
  getPhoneCodesList(e) {
    const t = this.locationApi.fetchPhoneCodesList(e);
    return this.transformPaginatedListToOptions(
      t,
      Q.getPhoneCodesAsOptions
    );
  }
  getSpanishResidenceCitiesList(e, t) {
    const n = this.locationApi.fetchSpanishResidenceCitiesList(
      e,
      t
    );
    return this.transformPaginatedListToOptions(
      n,
      Q.getSpanishCitiesAsOptions
    );
  }
  getLocationsByExternalUrl(e, t) {
    const n = this.locationApi.fetchLocationsByExternalUrl(e, t);
    return this.transformPaginatedListToOptions(
      n,
      Q.getSpanishCitiesAsOptions
    );
  }
}
function Ai(r) {
  throw new Error(r);
}
var Vt, sn;
function li() {
  if (sn) return Vt;
  sn = 1, Vt = function(n) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, h = void 0, f = void 0, S = void 0, v = [];
    return function() {
      var g = r(a), p = (/* @__PURE__ */ new Date()).getTime(), d = !h || p - h > g;
      h = p;
      for (var T = arguments.length, s = Array(T), c = 0; c < T; c++)
        s[c] = arguments[c];
      if (d && l.leading)
        return l.accumulate ? Promise.resolve(n.call(this, [s])).then(function(w) {
          return w[0];
        }) : Promise.resolve(n.call.apply(n, [this].concat(s)));
      if (f ? clearTimeout(S) : f = e(), v.push(s), S = setTimeout(b.bind(this), g), l.accumulate) {
        var u = v.length - 1;
        return f.promise.then(function(w) {
          return w[u];
        });
      }
      return f.promise;
    };
    function b() {
      var k = f;
      clearTimeout(S), Promise.resolve(l.accumulate ? n.call(this, v) : n.apply(this, v[v.length - 1])).then(k.resolve, k.reject), v = [], f = null;
    }
  };
  function r(t) {
    return typeof t == "function" ? t() : t;
  }
  function e() {
    var t = {};
    return t.promise = new Promise(function(n, a) {
      t.resolve = n, t.reject = a;
    }), t;
  }
  return Vt;
}
var pi = li();
const fi = /* @__PURE__ */ ua(pi);
function yi(r) {
  var e = null, t = null, n = new Promise(function(a, l) {
    e = a, t = l;
  });
  return r && r.then(function(a) {
    e && e(a);
  }, function(a) {
    t && t(a);
  }), {
    promise: n,
    resolve: function(a) {
      e && e(a);
    },
    reject: function(a) {
      t && t(a);
    },
    cancel: function() {
      e = null, t = null;
    }
  };
}
function di(r) {
  var e = null, t = function() {
    for (var n = [], a = 0; a < arguments.length; a++)
      n[a] = arguments[a];
    e && e();
    var l = r.apply(void 0, n), h = yi(l), f = h.promise, S = h.cancel;
    return e = S, f;
  };
  return t;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var zt = function() {
  return zt = Object.assign || function(e) {
    for (var t, n = 1, a = arguments.length; n < a; n++) {
      t = arguments[n];
      for (var l in t) Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
    }
    return e;
  }, zt.apply(this, arguments);
}, hi = {
  // One distinct debounced function is created per key and added to an internal cache
  // By default, the key is null, which means that all the calls
  // will share the same debounced function
  key: function() {
    return null;
  },
  // By default, a debounced function will only resolve
  // the last promise it returned
  // Former calls will stay unresolved, so that you don't have
  // to handle concurrency issues in your code
  // Setting this to false means all returned promises will resolve to the last result
  onlyResolvesLast: !0
}, gi = (
  /** @class */
  (function() {
    function r(e) {
      this.config = e, this.debounceSingleton = null, this.debounceCache = {};
    }
    return r.prototype._createDebouncedFunction = function() {
      var e = fi(this.config.func, this.config.wait, this.config.options);
      return this.config.options.onlyResolvesLast && (e = di(e)), {
        func: e
      };
    }, r.prototype.getDebouncedFunction = function(e) {
      var t, n = (t = this.config.options).key.apply(t, e);
      return n === null || typeof n > "u" ? (this.debounceSingleton || (this.debounceSingleton = this._createDebouncedFunction()), this.debounceSingleton) : (this.debounceCache[n] || (this.debounceCache[n] = this._createDebouncedFunction()), this.debounceCache[n]);
    }, r;
  })()
);
function vi(r, e, t) {
  var n = zt({}, hi, t), a = new gi({
    func: r,
    wait: e,
    options: n
  }), l = (function() {
    for (var h = [], f = 0; f < arguments.length; f++)
      h[f] = arguments[f];
    var S = a.getDebouncedFunction(h).func;
    return S.apply(void 0, h);
  });
  return l;
}
const mi = 500, bi = async (r) => {
  try {
    return !r || !r.trim() || await new vn().validatePhoneNumber(
      {
        phone: r
      },
      { errorRetryLimit: 0 }
    ), !0;
  } catch {
    return "invalid_phone_number";
  }
}, Jt = {}, wi = vi(async (r) => {
  const e = await bi(r);
  return Jt[r] = e, typeof e == "string" ? Fe.t(e) : e;
}, mi), Fi = {
  phoneValidateService: (r) => {
    const e = Dn(r);
    if (!(!e || !e.trim())) {
      if (Jt[e]) {
        const t = Jt[e];
        return typeof t == "string" ? Fe.t(t) : t;
      }
      return wi(e);
    }
  }
};
var Qt = /* @__PURE__ */ ((r) => (r.id = "id", r.reservation_id = "reservation_id", r.name = "name", r.surname = "surname", r.second_surname = "second_surname", r.birth_date = "birth_date", r.gender = "gender", r.nationality = "nationality", r.citizenship = "citizenship", r.document_type = "document_type", r.document_number = "document_number", r.document_issue_date = "document_issue_date", r.document_expiration_date = "document_expiration_date", r.document_expedition_country = "document_expedition_country", r.document_expedition_city = "document_expedition_city", r.document_expedition_municipality = "document_expedition_municipality", r.visa_number = "visa_number", r.purpose_of_stay = "purpose_of_stay", r.tax_exemption = "tax_exemption", r.full_tourist_tax = "full_tourist_tax", r.birth_place_country = "birth_place_country", r.birth_place_city = "birth_place_city", r.birth_place_municipality = "birth_place_municipality", r.birth_place_address = "birth_place_address", r.residence_country = "residence_country", r.residence_city = "residence_city", r.residence_community = "residence_community", r.residence_municipality = "residence_municipality", r.residence_province = "residence_province", r.residence_address = "residence_address", r.residence_street = "residence_street", r.residence_house_number = "residence_house_number", r.residence_postal_code = "residence_postal_code", r.arrived_from_country = "arrived_from_country", r.arrived_from_district = "arrived_from_district", r.arrived_from_municipality = "arrived_from_municipality", r.arrived_from_province = "arrived_from_province", r.next_destination_country = "next_destination_country", r.next_destination_district = "next_destination_district", r.next_destination_province = "next_destination_province", r.next_destination_address = "next_destination_address", r.next_destination_municipality = "next_destination_municipality", r.fiscal_code = "fiscal_code", r.email = "email", r.phone = "phone", r.second_phone = "second_phone", r.document_front_side_scan = "document_front_side_scan", r.document_back_side_scan = "document_back_side_scan", r.biomatch_doc = "biomatch_doc", r.biomatch_passed = "biomatch_passed", r.biomatch_selfie = "biomatch_selfie", r.ocr_passed = "ocr_passed", r.signature = "signature", r.biomatch_doc_id = "biomatch_doc_id", r.document_support_number = "document_support_number", r.kinship_relationship = "kinship_relationship", r.is_leader = "is_leader", r.external_category_id = "external_category_id", r.external_documents_biomatch_doc = "external_documents_biomatch_doc", r.external_documents_biomatch_doc_service = "external_documents_biomatch_doc_service", r.external_documents_biomatch_selfie = "external_documents_biomatch_selfie", r.external_documents_biomatch_selfie_service = "external_documents_biomatch_selfie_service", r.external_documents_front_side_scan = "external_documents_front_side_scan", r.external_documents_front_side_scan_service = "external_documents_front_side_scan_service", r.external_documents_back_side_scan = "external_documents_back_side_scan", r.external_documents_back_side_scan_service = "external_documents_back_side_scan_service", r.is_iv_failed = "is_iv_failed", r.liveness_video_link = "liveness_video_link", r.participant_id = "participant_id", r.force_show_leaders_fields = "force_show_leaders_fields", r.invoice_leader_type = "invoice_leader_type", r.recipient_code_type = "recipient_code_type", r.vat_number = "vat_number", r.recipient_code = "recipient_code", r.chip_card = "chip_card", r.mode_of_transport = "mode_of_transport", r.mother_name = "mother_name", r.mother_surname = "mother_surname", r))(Qt || {});
class ki {
  constructor() {
    this.algorithm = "AES-GCM", this.keyLength = 256;
  }
  async deriveKey(e, t, n = "api-response-encryption") {
    const a = new TextEncoder(), l = await crypto.subtle.importKey(
      "raw",
      a.encode(e),
      "HKDF",
      !1,
      ["deriveKey"]
    ), h = a.encode(t), f = a.encode(n);
    return await crypto.subtle.deriveKey(
      {
        name: "HKDF",
        hash: "SHA-256",
        salt: h,
        info: f
      },
      l,
      { name: this.algorithm, length: this.keyLength },
      !1,
      ["decrypt"]
    );
  }
  async decrypt(e, t) {
    const n = this.base64ToArrayBuffer(e?.data), a = this.base64ToArrayBuffer(e?.nonce), l = await crypto.subtle.decrypt(
      {
        name: this.algorithm,
        iv: a
      },
      t,
      n
    ), f = new TextDecoder().decode(l);
    return JSON.parse(f);
  }
  base64ToArrayBuffer(e) {
    const t = atob(e), n = new Uint8Array(t.length);
    for (let a = 0; a < t.length; a++)
      n[a] = t.charCodeAt(a);
    return n.buffer;
  }
}
class Si {
  constructor(e) {
    this.decryption = new ki(), this.decryptionKey = null, this.config = {
      masterKey: e.masterKey,
      salt: e.salt,
      info: e.info || "api-response-encryption",
      jwtToken: e.jwtToken || void 0,
      ...e
    };
  }
  async initialize() {
    if (!this.config.enabled) return null;
    if (!this.config.masterKey)
      throw new Error(
        "Decryption requires masterKey (should match ENCRYPTION_MASTER_KEY setting)"
      );
    if (!this.config.salt)
      throw new Error("Decryption requires salt (should match ENCRYPTION_SALT setting)");
    const e = this.config.jwtToken || this.config.info, t = await this.decryption.deriveKey(
      this.config.masterKey,
      this.config.salt,
      e
    );
    return this.decryptionKey = t, t;
  }
  setJwtToken(e) {
    this.config.jwtToken = e, this.decryptionKey = null;
  }
  getEncryptionHeaders() {
    return this.config.enabled ? {
      "X-Session-Type": "basic"
    } : {};
  }
  isResponseEncrypted(e) {
    return e.headers.get("X-Encrypted") === "true";
  }
  async decryptResponse(e, t) {
    let n = t || this.decryptionKey;
    return n || (n = await this.initialize()), await this.decryption.decrypt(e, n);
  }
  async getDecryptionKey() {
    return this.decryptionKey || await this.initialize(), this.decryptionKey;
  }
  isEnabled() {
    return this.config.enabled;
  }
}
const Ti = 1, Ki = () => {
  try {
    const r = oe.getToken();
    if (r !== null) {
      const e = r.split(".")[Ti], { user_id: t } = JSON.parse(atob(e));
      return t;
    }
  } catch (r) {
    console.error(r);
  }
  throw new Error("Failed to get user id");
};
function Oi(r) {
  return !!r?.instance_id;
}
const Pi = (r) => {
  const [e, t] = r?.build_hash?.split(".") || [];
  return { masterKey: e, salt: t };
};
class Ni {
  constructor(e) {
    this.authApi = new Ht(), this.configureDecryptionCallback = e;
  }
  async init(e, t) {
    const n = {
      apikey: e.apikey,
      resource_id: e.resourceId,
      external_resource_id: e.externalResourceId,
      resource_type: e.resourceType
    }, a = await this.authApi.getAuthToken(n, t);
    if (e.encryptionEnabled && this.configureDecryptionCallback) {
      const { masterKey: l, salt: h } = Pi(a);
      l && h && await this.configureDecryptionCallback({
        enabled: !0,
        masterKey: l,
        salt: h,
        jwtToken: a.access_token
      }).catch((f) => {
        console.error("Failed to configure decryption:", f);
      });
    }
    return a.access_token && oe.persistToken(a.access_token), a;
  }
  async initChekin(e, t) {
    const { body: n, headers: a } = await this.authApi.getChekinToken(
      { token: e },
      t
    ), l = a.get("Authorization");
    return n && oe.persistToken(Oi(n) ? l : n.user), n;
  }
  getIpDetails(e) {
    return this.authApi.fetchIpDetails(e);
  }
  async initiateUser(e, t) {
    return this.authApi.initiateUser(e, t);
  }
  async finalizeUser(e, t) {
    return this.authApi.finalizeUser(e, t);
  }
  async getGuestAccountToken(e, t) {
    return this.authApi.getToken(e, t);
  }
  async getMe(e) {
    return this.authApi.getMe(e);
  }
  async getParticipants(e) {
    return this.authApi.getParticipants(e);
  }
  async oauthGoogleCallback(e, t) {
    return this.authApi.oauthGoogleCallback(e, t);
  }
}
const Ei = "7qqmrt6doh.execute-api.eu-central-1.amazonaws.com/stg", _i = "api-ng.chekintest.xyz/api/v1/liveness-detection/ws/detect-position", Ri = "localhost:8765";
class Ii {
  connectWebSocket() {
    const e = oe.getToken(), t = `wss://${Ei}/?token=${e}`;
    return new WebSocket(t);
  }
  connectLivenessWebSocket() {
    const e = `wss://${_i}`;
    return new WebSocket(e);
  }
  connectKioskoWebSocket() {
    const e = `ws://${Ri}`;
    return new WebSocket(e);
  }
}
class $i {
  constructor() {
    this.guestApi = new ca();
  }
  getFileName(e, t) {
    return `${e}-${Qt[e]}.${t[e]?.type}`;
  }
  transformPayloadToFormData(e) {
    const t = new FormData();
    for (const n in e) {
      const a = n, l = e?.[a], h = a === Qt.signature && !l;
      if (l || l === !1) {
        const f = l.toString() || "";
        qn(l) ? t.append(a, l, this.getFileName(a, e)) : t.set(a, f);
      }
      h && t.set(a, "");
    }
    return t;
  }
  async getOne(e) {
    return this.guestApi.getOne(e);
  }
  async createOrUpdate({ data: { id: e, ...t } }, n, a) {
    if (!t) throw new Error("The payload or reservation id is missing");
    const l = this.transformPayloadToFormData(t);
    return e ? n ? await this.guestApi.patch(e, l, a) : await this.guestApi.put(e, l, a) : await this.guestApi.create(l, a);
  }
  createWithMinData(e, t) {
    return this.guestApi.createMin(e, t);
  }
  createGuestByParticipant(e, t) {
    return this.guestApi.createGuestByParticipant(e, t);
  }
  async delete(e, t) {
    if (!e) throw new Error("The guest id argument is not found");
    return await this.guestApi.delete(e, t);
  }
  async getSchema(e, t) {
    if (!e?.reservation_id)
      throw new Error("The reservation id argument is not found");
    return await this.guestApi.getSchema(e, t);
  }
  async livenessDetection(e, t) {
    return await this.guestApi.livenessDetection(e, t);
  }
  async searchForIV(e, t) {
    return await this.guestApi.searchForIV(e, t);
  }
}
const R = class R {
  static get initParams() {
    return K.initParams;
  }
  static set initParams(e) {
    K.setInitParams(e);
  }
  static get sdkVersion() {
    return K.sdkVersion;
  }
  static set sdkVersion(e) {
    K.sdkVersion = e;
  }
  static get isSDK() {
    return K.isSDK;
  }
  static get auth() {
    return {
      init: R._auth.init.bind(R._auth),
      initChekin: R._auth.initChekin.bind(R._auth),
      getIpDetails: R._auth.getIpDetails.bind(R._auth),
      initiateUser: R._auth.initiateUser.bind(R._auth),
      finalizeUser: R._auth.finalizeUser.bind(R._auth),
      getGuestAccountToken: R._auth.getGuestAccountToken.bind(R._auth),
      getMe: R._auth.getMe.bind(R._auth),
      getParticipants: R._auth.getParticipants.bind(R._auth),
      oauthGoogleCallback: R._auth.oauthGoogleCallback.bind(R._auth)
    };
  }
  static async initSDK(e) {
    if (!e.apikey)
      throw new Error("Chekin API key not found or not valid");
    K.setInitParams(e), K.setIsSDK(!0);
    const t = await R._auth.init(e);
    return t.access_token && K.setJwtToken(t.access_token), t;
  }
  static async init(e) {
    return K.setIsSDK(!1), R._auth.initChekin(e);
  }
  static async configureDecryption(e) {
    const t = new Si(e);
    e.enabled && await t.initialize(), Ie.setDecryptionManager(t);
  }
  static setJwtToken(e) {
    K.setJwtToken(e);
  }
  static isDecryptionEnabled() {
    return Ie.isDecryptionEnabled();
  }
};
R._auth = new Ni(R.configureDecryption), R.validations = new vn(), R.locations = new ui(), R.identityVerification = new za(), R.taxes = new Ja(), R.guestFormAdditionalData = new Qa(), R.documents = new Za(), R.guestGroup = new La(), R.payments = new Ya(), R.webSocket = new Ii(), R.guest = new $i(), R.reservation = new Va(), R.housing = new Xa(), R.upselling = new ti(), R.feedback = new oi(), R.verification = new si(), R.propertyProtection = new ri(), R.locks = new ni(), R.kiosko = new ci(), R.theme = new ai(), R.guidebooks = new ii();
let cn = R;
export {
  cn as API,
  Ht as AuthApi,
  Lt as CORS_ERRORS,
  ki as ChekinDecryption,
  Zt as DecryptionError,
  Si as DecryptionManager,
  Za as DocumentsApi,
  ln as ERROR_CODES,
  Jn as ERR_INTERNET_DISCONNECTED_MESSAGE,
  oi as FeedbackApi,
  Wn as GUEST_TOKEN_STORAGE_KEY,
  ca as GuestApi,
  Qa as GuestFormAdditionalDataApi,
  La as GuestGroupApi,
  Se as GuestTokenStorageHandler,
  ii as GuidebooksApi,
  Xa as HousingApi,
  Mi as IVStatus,
  za as IdentityVerificationApi,
  ci as KioskoApi,
  fn as LS_I18NEXT_LNG_KEY,
  Ha as LocationApi,
  ni as LocksApi,
  qi as MAX_RETRIES_REQUESTS_NUMBER,
  oe as MainTokenStorageHandler,
  Qt as PAYLOAD_FIELDS_NAMES,
  Ya as PaymentsApi,
  ri as PropertyProtectionApi,
  Gi as RETRY_ERROR_CODES,
  Va as ReservationApi,
  pn as TOKEN_STORAGE_KEY,
  Ja as TaxesApi,
  ai as ThemeApi,
  ti as UpsellingApi,
  Ui as VERIFICATION_METHODS,
  vn as ValidatorApi,
  Fi as Validators,
  si as VerificationApi,
  Bi as WS_EVENT_TYPES,
  y as apiClient,
  dn as buildRequestHeaders,
  Ai as displayError,
  je as getURL,
  Ki as getUserIdFromToken
};
//# sourceMappingURL=index.js.map
